import { Injectable, OnInit } from '@angular/core';
//import { Observable, of, throwError } from 'rxjs';
import { Observable, of, throwError, Subscriber } from 'rxjs';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { catchError, tap, map, takeUntil } from 'rxjs/operators';
import { Vertical } from '../Admin/vertical/vertical';
import { Publisher } from '../Admin/publisher/publisher';
import { Adnetwork } from '../Admin/adnetwork/adnetwork';
import { TableGeneral } from '../Admin/adnetwork/adnetwork';
import { Adnetworkapi } from '../Admin/adnetworkapi/adnetworkapi'
import { LandingPage } from '../Admin/landing/landing';
import { Menu } from '../Admin/menu/menu';
import { Rol } from '../Admin/rol/rol';
import { MenuRol } from '../Admin/menurole/menurole';
import { AdNetworkAPIResultField } from '../Admin/adnetworkapi/AdNetworkAPIResultField';
import { AdNetworkAPIParam } from '../Admin/adnetworkapi/adnetworkapiparam';
import { LandingPageAdNetworkParam } from '../Admin/langingconfigure/LandingPageAdNetworkParam';
import { LandingPageAdNetworkParamMapValue } from '../Admin/langingconfigure/LandingPageAdNetworkParamMapValue';
import { LandingPageAdNetworkAPI } from '../Admin/langingconfigure/LandingPageAdNetworkAPI';
import { AdvertiserReport } from '../Admin/reporting/AdvertiserReport';
import { AdCompany } from '../Admin/reporting/Company';
import { AdCampaign } from '../Admin/reporting/AdCampaign';
import { AdCampaignContstraValues } from '../Admin/reporting/AdCampaignContstraintValues';
import { AdCampaignScheduling } from '../Admin/reporting/AdCampaignScheduling';
import { Users } from '../Admin/reporting/Users';
import { MailNotification } from '../Admin/Mail';
import { AdCompanyVertical } from '../Admin/reporting/AdCompanyVertical';
import { AdCampaignURLDynamicValue } from '../Admin/reporting/AdCampaignURLDynamicValue';
import data_settingMAO from '../../assets/json/MaoProject.json';
import { PublisherVertical } from '../Admin/publisherreporting/clases/PublisherVertical';
import { LandingPageAdFeedParam } from '../Admin/landingconfigurefeed/LandingPageAdFeedParam';
import { LandingPageAdFeed } from '../Admin/landingconfigurefeed/LandingPageAdFeed';
import { LandingPageAdFeedParamMapValue } from '../Admin/landingconfigurefeed/LandingPageAdFeedParamMapValue';
import { AdCampaignUser } from '../Admin/reporting/AdCampaignUser';
import { AdCampaignBulk } from '../Admin/reporting/AdCampaignBulk';
import { AdCompanyBulk } from '../Admin/reporting/CompanyBulk';
import { ForgotPasswordComponent } from '../pages/forgot-password/forgot-password.component';
import { AdUserRecovery, ForgotPassword } from '../pages/AdUserRecovery';
import { param } from 'jquery';
import { CampaignAdCopy } from '../Admin/advertiser-campaign/models/campaign-ad-copy.model';
import { BudgetAlert } from '../Admin/publisher/Models/budget-alert.model';
import { AdminCallReport } from '../Admin/admin-call-report/models/admin-call-report.model';
import { DataCenterParams, ReportConfiguration } from '../Admin/data-center/data-center';
import { InventoryRequest } from '../Admin/inventory-report/models/inventory-request.model';
import { ExternalReportApi } from '../Admin/external-report-apis/external-report-api';
import { ExternalReportAPIParam } from '../Admin//external-report-apis/external-report-api-param';
import { ExternalReportAPIResultParamMap } from '../Admin/external-report-apis/external-report-api-result-param-map';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json', 'withCredentials': 'true', 'Authorization': 'true' })
};


const hostGeneral = data_settingMAO.RestApi;
const hostTwilio = data_settingMAO.TwilioServer;
//const hostGeneral = `http://localhost:53356-44444`;
let headers: any = {};
@Injectable({
  providedIn: 'root'
})

export class ApiService implements OnInit {
  //hostGeneral
  //postUrlVertical = hostGeneral+ '/api/Verticals/SaveVertical';
  postUrlDelete = hostGeneral + '/api/Verticals/DeleteVertical';
  myItemSession: any;
  httpOptions2: any = {};


  constructor(private http: HttpClient) {
    //const headers = { 'Content-Type': 'application/json', 'withCredentials': 'true', 'Authorization': 'true', 'Token': this.myItemSession.Token };  
  }
  //public static get HOME_URL(): string { return "sample/url/"; };
  vertical: Observable<any>;
  baseURL = "https://reqres.in";

  headers: HttpHeaders = new HttpHeaders({
    'Content-Type': 'application/json',
    //Authorization: localStorage.getItem("accessToken")
  });

  ngOnInit() {
  }

  SetHeadersToken() {
    this.myItemSession = localStorage.getItem("SessionMAO");

    if (this.myItemSession == null) {
      let key = "SessionMAO";
      let valueSession = { validate: 'false', name: '' };
      localStorage.setItem(key, JSON.stringify(valueSession));
      this.myItemSession = localStorage.getItem("SessionMAO");
    }

    this.myItemSession = JSON.parse(this.myItemSession);
    this.httpOptions2 = {
      headers: new HttpHeaders({ 
        'Content-Type': 'application/json'
      })
    };

    headers = { 'Content-Type': 'application/json',
      'RoleID': this.myItemSession.RoleID == undefined ? null : this.myItemSession.RoleID.toString() 
    };
  }

  SetLocalStorage(NameStorage: string, ValueStorage: object) {
    let key = NameStorage;
    localStorage.setItem(key, JSON.stringify(ValueStorage));
  }

  SetHeadersTokenbackup() {

    this.myItemSession = localStorage.getItem("SessionMAO");
    this.myItemSession = JSON.parse(this.myItemSession);
    if (this.myItemSession != null) {
      this.httpOptions2 = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json', 'withCredentials': 'true', 'Authorization': 'true', 'Token': this.myItemSession.Token })
      };
      headers = { 'Content-Type': 'application/json', 'withCredentials': 'true', 'Authorization': 'true', 'Token': '' };
    }
    else {
      this.httpOptions2 = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json', 'withCredentials': 'true', 'Authorization': 'true', 'Token': '' })
      };
      headers = { 'Content-Type': 'application/json', 'withCredentials': 'true', 'Authorization': 'true', 'Token': '' };
    }
  }

  saveCompanyBulk(post: Array<AdCompanyBulk>): Observable<Array<AdCompanyBulk>> {
    return this.http.post<Array<AdCompanyBulk>>(`${hostGeneral}/api/Company/SaveBulk`, post, { headers });
  }

  saveCampaignBulk(post: Array<AdCampaignBulk>): Observable<Array<AdCampaignBulk>> {
    return this.http.post<Array<AdCampaignBulk>>(`${hostGeneral}/api/AdCampaign/SaveBulk`, post, { headers });
  }

  // **** 2022-08-26 JFRH: saveConstraintsBulk(): Actualizar Bulk Modify Constraints
  saveConstraintsBulk(post: Array<any>): Observable<Array<any>> {
    return this.http.post<Array<AdCampaignBulk>>(`${hostGeneral}/api/AdCampaign/SaveConstraintsBulk`, post, { headers });
  }

  saveVertical(post: Vertical): Observable<Vertical> {
    //return this.http.post<Vertical>(this.postUrlVertical,post,httpOptions);
    return this.http.post<Vertical>(`${hostGeneral}/api/Verticals/SaveVertical`, post, { headers });
  }

  saveAdCompanyAdFeed(post: any): Observable<any> {
    //return this.http.post<Vertical>(this.postUrlVertical,post,httpOptions);
    return this.http.post<any>(`${hostGeneral}/api/AdCompanyAdFeed/Save`, post, { headers });
  }

  savePublisher(post: Publisher): Observable<Publisher> {
    return this.http.post<Publisher>(`${hostGeneral}/api/Publishers/SavePublisher`, post, { headers });
  }

  // **** 2025-11-13 JFRH: saveExternalReportApi(): Save External Report API
  saveExternalReportApi(post: ExternalReportApi): Observable<ExternalReportApi> {
    return this.http.post<ExternalReportApi>(`${hostGeneral}/api/ExternalReportApi/SaveExternalReportApi`, post, { headers });
  }

  // **** 2025-11-13 JFRH: deleteExternalReportApi(): Delete External Report API
  deleteExternalReportApi(post: ExternalReportApi): Observable<ExternalReportApi> {
    return this.http.post<ExternalReportApi>(`${hostGeneral}/api/ExternalReportApi/DeleteExternalReportApi`, post, { headers });
  }

  saveAdNetworkAPI(post: Adnetworkapi): Observable<Adnetworkapi> {
    return this.http.post<Adnetworkapi>(`${hostGeneral}/api/AdNetworkAPI/SaveAdNetworkAPI`, post, { headers });
  }

  saveAdNetwork(post: Adnetwork): Observable<Adnetwork> {
    return this.http.post<Adnetwork>(`${hostGeneral}/api/AdNetworks/SaveAdNetwork`, post, { headers });
  }

  saveLandingPage(post: LandingPage): Observable<LandingPage> {
    return this.http.post<LandingPage>(`${hostGeneral}/api/LandingPage/SaveLandingPage`, post, { headers });
  }

  saveMenu(post: Menu): Observable<Menu> {
    return this.http.post<Menu>(`${hostGeneral}/api/Menu/SaveMenu`, post, { headers });
  }
  saveRol(post: Rol): Observable<Rol> {
    return this.http.post<Rol>(`${hostGeneral}/api/rol/SaveRol`, post, { headers });
  }

  saveMenuRol(post: MenuRol): Observable<MenuRol> {
    return this.http.post<MenuRol>(`${hostGeneral}/api/MenuRol/SaveMenuRol`, post, { headers });
  }

  saveMapResult(post: AdNetworkAPIResultField): Observable<AdNetworkAPIResultField> {
    return this.http.post<AdNetworkAPIResultField>(`${hostGeneral}/api/AdNetworkAPIResultField/SaveAdNetworkAPIResult`, post, { headers });
  }

  saveAPIParam(post: AdNetworkAPIParam): Observable<AdNetworkAPIParam> {
    return this.http.post<AdNetworkAPIParam>(`${hostGeneral}/api/AdNetworkAPIParam/SaveAdNetworkAPIParam`, post, { headers });
  }

  getTimeoutSeconds(reportId: number): Promise<number> {
    const url = `${hostGeneral}/api/ReportConfiguration/GetReportTimeoutByReportID`;
    const params = new HttpParams().set('reportId', String(reportId));
    return this.http.get<number>(url, { params }).toPromise();
  }

  // **** 2023-11-06 JFRH: Queue to send Data Center report
  sendDCQueueMessage(post: DataCenterParams, UserID: any): Observable<DataCenterParams> {
    let paramsx = new HttpParams().set("UserID", UserID); //Create new HttpParams
    const options2 = { headers: headers, params: paramsx }
    return this.http.post<DataCenterParams>(`${hostGeneral}/api/DataCenter/sendDCQueueMessage`, post, options2);
  }

  // **** 2025-09-08 JBDCR: Queue to send Admin Report
  sendAdminReportQueueMessage(payload: any): Observable<any> {
    const options = { headers };
    return this.http.post<any>(`${hostGeneral}/api/AdminReport/sendAdminReportQueueMessage`, payload, options);
  }

  // **** 2025-09-08 JBDCR: Queue to send Admin Call Report
  sendAdminCallReportQueueMessage(payload: any): Observable<any> {
    const options = { headers };
    return this.http.post<any>(`${hostGeneral}/api/AdminCallReport/sendAdminCallReportQueueMessage`, payload, options);
  }

  // **** 2025-09-08 JBDCR: Queue to send Admin Call Report
  sendAdvertiserReportQueueMessage(payload: any): Observable<any> {
    const options = { headers };
    return this.http.post<any>(`${hostGeneral}/api/AdvertiserReport/sendAdvertiserReportQueueMessage`, payload, options);
  }

  // **** 2025-09-08 JBDCR: Queue to send Admin Call Report
  sendDataCenterCallsReportQueueMessage(payload: any): Observable<any> {
    const options = { headers };
    return this.http.post<any>(`${hostGeneral}/api/DataCenterCallsReport/sendDataCenterCallsReportQueueMessage`, payload, options);
  }

  // **** 2025-09-08 JBDCR: Queue to send Admin Call Report
  sendLeadReportQueueMessage(payload: any): Observable<any> {
    const options = { headers };
    return this.http.post<any>(`${hostGeneral}/api/LeadAdminReport/sendLeadReportQueueMessage`, payload, options);
  }

  SetCloudQueueMessage(post: LandingPage, UserID: any): Observable<LandingPage> {
    //const options = { params: new HttpParams().set('User', UserID) };
    let paramsx = new HttpParams().set("User", UserID); //Create new HttpParams
    const options2 = { headers: headers, params: paramsx }
    //const options = { 'Content-Type': 'application/json', 'withCredentials': 'true', 'Authorization': 'true', 'Token': this.myItemSession.Token };
    return this.http.post<LandingPage>(`${hostGeneral}/api/LandingPage/SetCloudQueueMessage`, post, options2);
    //return this.http.post<LandingPage>(`${hostGeneral}/api/LandingPage/SetCloudQueueMessage`, post, httpOptions);
  }

  saveLandingPageAdNetwork(post: LandingPageAdNetworkAPI): Observable<LandingPageAdNetworkAPI> {
    return this.http.post<LandingPageAdNetworkAPI>(`${hostGeneral}/api/LandingPageAdNetworkAPI/SaveLandingPageAdNetwork`, post, { headers });
  }

  // **** 2023-11-20 JFRH: Get ReportConfiguration by ReportID
  getReportConfigurationByReportID(ReportID) {
    var url = hostGeneral + "/api/ReportConfiguration/GetReportConfigurationByReportID";
    let paramsx = new HttpParams().set("ReportID", ReportID);
    return this.http.get(url, { headers: headers, params: paramsx }).toPromise();
  }

  // **** 2025-11-26 JBDCR: Cancel Report Run
  cancelReportRun(token: string): Promise<{ cancelled: boolean }> {
    const url = `${data_settingMAO.RestApi}/api/ReportConfiguration/CancelReportRun`;
    return this.http.post<{ cancelled: boolean }>(url, null, { params: { token } }).toPromise();
  }

  // **** 2023-11-20 JFRH: saveReportConfiguration
  saveReportConfiguration(post: ReportConfiguration): Observable<ReportConfiguration> {
    return this.http.post<ReportConfiguration>(`${hostGeneral}/api/ReportConfiguration/Save`, post, { headers });
  }

  saveLandingPageAdNetworkParam(post: LandingPageAdNetworkParam): Observable<LandingPageAdNetworkParam> {
    return this.http.post<LandingPageAdNetworkParam>(`${hostGeneral}/api/LandingPageAdNetworkParam/SaveLandingPageAdnetworkParam`, post, { headers });
  }

  saveLandingPageAdFeedParam(post: LandingPageAdFeedParam): Observable<LandingPageAdFeedParam> {

    return this.http.post<LandingPageAdFeedParam>(`${hostGeneral}/api/LandingPageAdFeedParam/SaveLandingPageAdFeedParam`, post, { headers });
  }

  saveLandingPageAdNetworkParamMapValue(post: LandingPageAdNetworkParamMapValue): Observable<LandingPageAdNetworkParamMapValue> {
    return this.http.post<LandingPageAdNetworkParamMapValue>(`${hostGeneral}/api/LandingPageAdNetworkParamMapValue/SaveLandingPageAdnetworkParamMapValue`, post, { headers });
  }

  saveLandingPageAdFeedParamMapValue(post: LandingPageAdFeedParamMapValue): Observable<LandingPageAdFeedParamMapValue> {
    return this.http.post<LandingPageAdFeedParamMapValue>(`${hostGeneral}/api/LandingPageAdFeedParamMapValue/SaveLandingPageAdFeedParamMapValue`, post, { headers });
  }

  saveCompany(post: AdCompany): Observable<AdCompany> {
    return this.http.post<AdCompany>(`${hostGeneral}/api/Company/Save`, post, { headers });
  }

  saveAdvertiserFromCampaign(post: any): Observable<any> {
    return this.http.post<any>(`${hostGeneral}/api/Company/Save`, post, { headers });
  }

  DeleteCompany(post: AdCompany): Observable<AdCompany> {
    return this.http.post<AdCompany>(`${hostGeneral}/api/Company/Delete`, post, { headers });
  }


  saveCompanyVertical(post: AdCompanyVertical): Observable<AdCompanyVertical> {
    return this.http.post<AdCompanyVertical>(`${hostGeneral}/api/AdCompanyVertical/Save`, post, { headers });
  }

  saveCampaign(post: AdCampaign): Observable<AdCampaign> {
    return this.http.post<AdCampaign>(`${hostGeneral}/api/AdCampaign/Save`, post, { headers });
  }

  updateCustomVarCampaign(post: any): Observable<any> {
    return this.http.post<any>(`${hostGeneral}/api/AdCampaign/UpdateCustomVar`, post, { headers });
  }

  /**
   * updatePrgAdCopyCustomVar(): Update CustomVars for (Program) AdCopy (CampaignAdCopy)
   * @param post CampaignAdCopy_M parameter
   * @returns 
   */
  savePrgAdCopyCustomVar(post: any): Observable<any> {
    return this.http.post<any>(`${hostGeneral}/api/AdCampaign/SavePrgAdCopyCustomVar`, post, { headers });
  }

  // **** 2020-08-03 JFRH: Se agrega método SaveAdminLog() para accesar API de log en tabla AdminUILog
  saveAdminLog(post: any): Observable<any> {
    return this.http.post<any>(`${hostGeneral}/api/AdminUILog/SaveLog`, post, { headers });
  }

  // **** 2020-08-26 JFRH: Se agrega método getAdminLogModulesList() para traer lista de módulos de log de tabla AdminUILogModules
  getAdminLogModulesList() {
    return this.http.get(`${hostGeneral}/api/AdminUILog/GetAdminLogModulesList`, this.httpOptions2).toPromise();
  }

  // **** 2020-08-30 JFRH: método getDataAdminUILogReportBySP() para obtener datos de tabla AdminUILog por SP GetAdminUILogReport
  getDataAdminUILogReportBySP(ModuleUIID, VerticalID, PublisherID, UserID, ItemID, StartDate, EndDate,
    ShowAllPublisher, ShowAllUser, ShowAllItemID, SessionUserID, RoleID) {
    let paramsx = new HttpParams();
    var urlAdminUILog = hostGeneral + "/api/AdminUILog/GetAdminUILogReportBySP";
    paramsx = paramsx.append("ModuleUIID", ModuleUIID);
    paramsx = paramsx.append("VerticalID", VerticalID);
    paramsx = paramsx.append("PublisherID", PublisherID);
    paramsx = paramsx.append("UserID", UserID);
    paramsx = paramsx.append("ItemID", ItemID);
    paramsx = paramsx.append("StartDate", this.ReturnYMD(StartDate));
    paramsx = paramsx.append("EndDate", this.ReturnYMD(EndDate));
    paramsx = paramsx.append("ShowAllPublisher", ShowAllPublisher);
    paramsx = paramsx.append("ShowAllUser", ShowAllUser);
    paramsx = paramsx.append("ShowAllItemID", ShowAllItemID);
    paramsx = paramsx.append("SessionUserID", SessionUserID);
    paramsx = paramsx.append("RoleID", RoleID);
    return this.http.get(urlAdminUILog, { headers: headers, params: paramsx }).toPromise();

  }

  saveAdCompanyBudgetLog(post: any): Observable<any> {
    return this.http.post<any>(`${hostGeneral}/api/AdCompanyBudgetLog/Save`, post, httpOptions);
  }

  saveAdCampaignBudgetLog(post: any): Observable<any> {
    return this.http.post<any>(`${hostGeneral}/api/AdCampaignBudgetLog/Save`, post, httpOptions);
  }


  updateRowAdCampaign(post: AdCampaign): Observable<AdCampaign> {
    return this.http.post<AdCampaign>(`${hostGeneral}/api/AdCampaign/UpdateRowAdCampaign`, post, { headers });
  }



  updateRowAdCampaignByCap(post: AdCampaign): Observable<AdCampaign> {
    return this.http.post<AdCampaign>(`${hostGeneral}/api/AdCampaign/UpdateRowAdCampaignByCap`, post, { headers });
  }

  updateRowAdCampaignByCapWithLog(post: any): Observable<any> {
    return this.http.post<any>(`${hostGeneral}/api/AdCampaign/UpdateRowAdCampaignByCapWithLog`, post, { headers });
  }

  updateRowAdCompany(post: AdCompany): Observable<AdCompany> {
    return this.http.post<AdCompany>(`${hostGeneral}/api/Company/UpdateRowAdCompany`, post, { headers });
  }

  updateRowAdCompanyWithLog(post: any): Observable<any> {
    return this.http.post<any>(`${hostGeneral}/api/Company/UpdateRowAdCompanyWithLog`, post, { headers });
  }

  updateSourceIDConstraints(sourceIDList: AdCampaignContstraValues[]) {
    return this.http.post<AdCampaignContstraValues[]>(`${hostGeneral}/api/AdCampaignConstraintValue/UpdateSourceIDConstraints`, sourceIDList, { headers });
  }

  saveCampaignConstraintValues(post: AdCampaignContstraValues): Observable<AdCampaignContstraValues> {
    return this.http.post<AdCampaignContstraValues>(`${hostGeneral}/api/AdCampaignConstraintValue/Save`, post, { headers });
  }

  saveSourceIdConstraints(sourceIDList: AdCampaignContstraValues[]) {
    return this.http.post<AdCampaignContstraValues[]>(`${hostGeneral}/api/AdCampaignConstraintValue/SaveSourceIDConstraints`, sourceIDList, { headers });
  }

  // Bulk upsert of exchange rules (BidModifierBySourceIDs), called from the Bulk Upload wizard
  saveGlobalSourceConstraintsBulk(ruleList: any[]) {
    return this.http.post<any>(`${hostGeneral}/api/BidModifierBySourceID/SaveGlobalSourceConstraintsBulk`, ruleList, { headers });
  }

  GetDomainsByCompany(AdCompanyID) {
    let params = new HttpParams();
    params = params.append("AdCompanyID", AdCompanyID);

    return this.http.get<any>(`${hostGeneral}/api/AdDomain/GetDomainsByCompany`, { headers, params });
  }

  GetSourceIdListByCampaignID(AdCampaignID) {
    let params = new HttpParams();
    params = params.append("AdCampaignID", AdCampaignID);

    return this.http.get<AdCampaignContstraValues[]>(`${hostGeneral}/api/AdCampaignConstraintValue/GetSourceIdListByCampaignID`, { headers, params });
  }

  deleteSourceIdConstraints(sourceIDList: AdCampaignContstraValues[]) {
    return this.http.post<AdCampaignContstraValues[]>(`${hostGeneral}/api/AdCampaignConstraintValue/RemoveSourceIdConstraints`, sourceIDList, { headers });
  }

  saveCampaignConstraintValuesInclusive(post: AdCampaignContstraValues): Observable<AdCampaignContstraValues> {
    return this.http.post<AdCampaignContstraValues>(`${hostGeneral}/api/AdCampaignConstraintValue/SaveInclusive`, post, { headers });
  }

  saveAllCampaignConstraintValues(post: any): Observable<any> {
    return this.http.post<any>(`${hostGeneral}/api/AdCampaignConstraintValue/SaveAllConstraint`, post, { headers });
  }

  saveAllCampaignConstraintChildren(post: any): Observable<any> {
    return this.http.post<any>(`${hostGeneral}/api/AdCampaignConstraintValue/SaveAllConstraintChildren`, post, { headers });
  }

  SetConstraintsToExactMatch(post: any, method): Observable<any> {
    return this.http.post<any>(`${hostGeneral}/api/AdCampaignConstraintValue/${method}`, post, { headers });
  }


  DeleteAllCampaignConstraintValues(post: any): Observable<any> {
    return this.http.post<any>(`${hostGeneral}/api/AdCampaignConstraintValue/DeleteAllConstraint`, post, { headers });
  }

  DeleteAllCampaignConstraintChildren(post: any): Observable<any> {
    return this.http.post<any>(`${hostGeneral}/api/AdCampaignConstraintValue/DeleteAllConstraintChildren`, post, { headers });
  }

  requestUnlockSourceIdConstraint(sourceIDList: AdCampaignContstraValues) {
    return this.http.post<AdCampaignContstraValues[]>(`${hostGeneral}/api/AdCampaignConstraintValue/RequestUnlockSourceIdConstraint`, sourceIDList, { headers });
  }




  saveCampaignScheduling(post: AdCampaignScheduling): Observable<AdCampaignScheduling> {
    return this.http.post<AdCampaignScheduling>(`${hostGeneral}/api/AdCampaignScheduling/Save`, post, { headers });
  }

  saveCampaignSchedulingList(post: Array<AdCampaignScheduling>): Observable<Array<AdCampaignScheduling>> {
    return this.http.post<Array<AdCampaignScheduling>>(`${hostGeneral}/api/AdCampaignScheduling/SaveScheduler`, post, { headers });
  }

  // **** 2021-12-01 JFRH saveCampaignSchedulingListIndiv(): Llamada a API para guardar una lista individual de Scheduling
  saveCampaignSchedulingListIndiv(post: Array<AdCampaignScheduling>): Observable<Array<AdCampaignScheduling>> {
    return this.http.post<Array<AdCampaignScheduling>>(`${hostGeneral}/api/AdCampaignScheduling/SaveSchedulerList`, post, { headers });
  }




  saveUsers(post: Users): Observable<Users> {
    return this.http.post<Users>(`${hostGeneral}/api/UserAuth/Save`, post, httpOptions);
  }

  requestPassword(post: ForgotPassword): Observable<ForgotPassword> {
    return this.http.post<ForgotPassword>(`${hostGeneral}/api/UserAuth/ForgotPassword`, post, httpOptions);

  }

  passwordrecovery(post: any): Observable<any> {
    return this.http.post<any>(`${hostGeneral}/api/UserAuth/PasswordRecovery`, post, httpOptions);

  }

  saveCampaignUser(post: any): Observable<any> {
    return this.http.post<any>(`${hostGeneral}/api/CampaignUser/Save`, post, httpOptions);
  }

  updateVisibleCampaignUser(post: any): Observable<any> {
    return this.http.post<any>(`${hostGeneral}/api/CampaignUser/UpdateVisible`, post, httpOptions);
  }

  SaveNewUsersByNewCampaign(post: any): Observable<any> {
    return this.http.post<any>(`${hostGeneral}/api/CampaignUser/SaveAllUserByPublisher`, post, httpOptions);
  }

  SaveCampaignUserByPublisher(post: any): Observable<any> {
    return this.http.post<any>(`${hostGeneral}/api/CampaignUser/SaveCampaignByPublisher`, post, httpOptions);
  }

  validateUser(post: Users): Observable<Users> {
    return this.http.post<Users>(`${hostGeneral}/api/UserAuth/ValidateEmail`, post, httpOptions);
  }

  validateUserCampaign(post: any): Observable<any> {
    return this.http.post<any>(`${hostGeneral}/api/UserAuth/ValidateEmailCampaign`, post, httpOptions);
  }


  saveCampaignURLDynamic(post: AdCampaignURLDynamicValue): Observable<AdCampaignURLDynamicValue> {
    return this.http.post<AdCampaignURLDynamicValue>(`${hostGeneral}/api/AdCampaignURLDynamicValues/Save`, post, { headers });
  }

  saveAdCompanyVertical(post: AdCompanyVertical): Observable<AdCompanyVertical> {
    return this.http.post<AdCompanyVertical>(`${hostGeneral}/api/AdCompanyVertical/Save`, post, { headers });
  }

  savePublisherVertical(post: PublisherVertical): Observable<PublisherVertical> {
    return this.http.post<PublisherVertical>(`${hostGeneral}/api/PublisherVertical/Save`, post, { headers });
  }

  SendNotificationNewCampaign(post: MailNotification): Observable<MailNotification> {
    return this.http.post<MailNotification>(`${hostGeneral}/api/UtilityMail/NotificationNewCampaign`, post, httpOptions);
  }

  SendNotificationCollaborateCampaign(post: MailNotification): Observable<MailNotification> {
    return this.http.post<MailNotification>(`${hostGeneral}/api/UtilityMail/NotificationCollaborateCampaign`, post, httpOptions);
  }

  SendNotificationCredentials(post: MailNotification): Observable<MailNotification> {
    return this.http.post<MailNotification>(`${hostGeneral}/api/UtilityMail/NotificationCredentials`, post, httpOptions);
  }

  SendNotificationEmail(post: MailNotification): Observable<MailNotification> {
    return this.http.post<MailNotification>(`${hostGeneral}/api/UtilityMail/NotificationGeneralEmail`, post, httpOptions);
  }



  // --- Delete ---------------------------------------

  deleteCampaignURLDynamic(post: AdCampaignURLDynamicValue): Observable<AdCampaignURLDynamicValue> {
    return this.http.post<AdCampaignURLDynamicValue>(`${hostGeneral}/api/AdCampaignURLDynamicValues/Delete`, post, { headers });
  }

  deleteAdCompanyVertical(post: AdCompanyVertical): Observable<AdCompanyVertical> {
    return this.http.post<AdCompanyVertical>(`${hostGeneral}/api/AdCompanyVertical/Delete`, post, { headers });
  }

  deletePublisherVertical(post: PublisherVertical): Observable<PublisherVertical> {
    return this.http.post<PublisherVertical>(`${hostGeneral}/api/PublisherVertical/Delete`, post, { headers });
  }

  deleteCampaignConstraintValue(post: AdCampaignContstraValues): Observable<AdCampaignContstraValues> {
    return this.http.post<AdCampaignContstraValues>(`${hostGeneral}/api/AdCampaignConstraintValue/Delete`, post, { headers });
  }

  deleteCampaignConstraintValueChildren(post: AdCampaignContstraValues): Observable<AdCampaignContstraValues> {
    return this.http.post<AdCampaignContstraValues>(`${hostGeneral}/api/AdCampaignConstraintValue/DeleteChildren`, post, { headers });
  }


  deleteLandingPageAdNetwork(post: LandingPageAdNetworkAPI): Observable<LandingPageAdNetworkAPI> {
    return this.http.post<LandingPageAdNetworkAPI>(`${hostGeneral}/api/LandingPageAdNetworkAPI/DeleteLandingPageAdNetwork`, post, { headers });
  }
  // Delete Options
  deleteVertical(post: Vertical): Observable<Vertical> {
    return this.http.post<Vertical>(this.postUrlDelete, post, { headers });
  }
  deletePublisher(post: Publisher): Observable<Publisher> {
    return this.http.post<Publisher>(`${hostGeneral}/api/Publishers/DeletePublisher`, post, { headers });

  }
  deleteAdNetwork(post: Adnetwork): Observable<Adnetwork> {
    return this.http.post<Adnetwork>(`${hostGeneral}/api/AdNetworks/DeleteAdNetwork`, post, { headers });
  }


  deleteLandingPage(post: LandingPage): Observable<LandingPage> {
    return this.http.post<LandingPage>(`${hostGeneral}/api/LandingPage/DeleteLandingPage`, post, { headers });
  }
  deleteMenu(post: Menu): Observable<Menu> {
    return this.http.post<Menu>(`${hostGeneral}/api/Menu/DeleteMenu`, post, { headers });
  }
  deleteRol(post: Rol): Observable<Rol> {
    return this.http.post<Rol>(`${hostGeneral}/api/Rol/DeleteRol`, post, { headers });
  }
  deleteMenuRol(post: MenuRol): Observable<MenuRol> {
    return this.http.post<MenuRol>(`${hostGeneral}/api/MenuRol/DeleteMenuRol`, post, { headers });
  }
  deleteAPIParam(post: AdNetworkAPIParam): Observable<AdNetworkAPIParam> {
    return this.http.post<AdNetworkAPIParam>(`${hostGeneral}/api/AdNetworkAPIParam/DeleteAdNetworkAPIParam`, post, { headers });
  }

  deleteAPIMapResult(post: AdNetworkAPIParam): Observable<AdNetworkAPIParam> {
    return this.http.post<AdNetworkAPIParam>(`${hostGeneral}/api/AdNetworkAPIResultField/DeleteAdNetworkAPIResult`, post, { headers });
  }

  deleteLandingPageAdnetParamMapValue(post: LandingPageAdNetworkParamMapValue): Observable<LandingPageAdNetworkParamMapValue> {
    return this.http.post<LandingPageAdNetworkParamMapValue>(`${hostGeneral}/api/LandingPageAdNetworkParamMapValue/DeleteLandingPageAdnetworkParamMapValue`, post, { headers });
  }

  deleteLandingPageAdFeedParamMapValue(post: LandingPageAdFeedParamMapValue): Observable<LandingPageAdFeedParamMapValue> {
    return this.http.post<LandingPageAdFeedParamMapValue>(`${hostGeneral}/api/LandingPageAdFeedParamMapValue/DeleteLandingPageAdFeedParamMapValue`, post, { headers });
  }

  deleteLandingPageAdFeedParam(post: LandingPageAdFeedParamMapValue): Observable<LandingPageAdFeedParamMapValue> {
    return this.http.post<LandingPageAdFeedParamMapValue>(`${hostGeneral}/api/LandingPageAdFeedParam/DeleteLandingPageAdFeedParam`, post, { headers });
  }

  CloneCampaign(post: AdCampaign): Observable<AdCampaign> {
    //return this.http.post<Vertical>(this.postUrlVertical,post,httpOptions);
    return this.http.post<AdCampaign>(`${hostGeneral}/api/AdCampaign/CloneCampaign`, post, { headers });
  }

  removeAdCampaignUser(post: AdCampaignUser): Observable<AdCampaignUser> {
    //return this.http.post<Vertical>(this.postUrlVertical,post,httpOptions);
    return this.http.post<AdCampaignUser>(`${hostGeneral}/api/CampaignUser/RemoveCollaborator`, post, { headers });
  }

  getCampaignUserByCampaign(post: any): Observable<Vertical> {
    //return this.http.post<Vertical>(this.postUrlVertical,post,httpOptions);
    return this.http.post<any>(`${hostGeneral}/api/CampaignUser/GetCampaignUserByCampaign`, post, { headers });
  }

  GetCollaboratorCampaign(post: any): Observable<Vertical> {
    //return this.http.post<Vertical>(this.postUrlVertical,post,httpOptions);
    return this.http.post<any>(`${hostGeneral}/api/CampaignUser/GetCollaboratorCampaign`, post, { headers });
  }

  getPublisherByAdFeed(post: any): Observable<Vertical> {
    //return this.http.post<Vertical>(this.postUrlVertical,post,httpOptions);
    return this.http.post<any>(`${hostGeneral}/api/CampaignUser/GetCampaignUserByCampaign`, post, { headers });
  }


  ValidExistUser(Email: any) {
    var url = hostGeneral + "/api/UserAuth/VerifyExistUser";
    let paramsx = new HttpParams().set("Email", Email); //Create new HttpParams
    return this.http.get(url, { params: paramsx }).toPromise();
  }


  getTokenTwilio() {
    var url = hostTwilio + "/api/TwilioVoiceAPI/Token/Get";
    return this.http.get(url, this.httpOptions2).toPromise();
  }



  CloneCampaignGet(AdCampaignID) {
    var url = hostGeneral + "/api/AdCampaign/CloneCampaign";
    let paramsx = new HttpParams().set("AdCampaignID", AdCampaignID); //Create new HttpParams
    return this.http.get(url, { headers: headers, params: paramsx }).toPromise();
  }


  // Get Data Options
  getUsersListByCompany(CompanyID) {
    var url = hostGeneral + "/api/UserAuth/GetUserByCompany";
    let paramsx = new HttpParams().set("CompanyID", CompanyID); //Create new HttpParams
    return this.http.get(url, { params: paramsx }).toPromise();
  }

  getTokenCollaboratorsByUser(UserID: any) {
    var url = hostGeneral + "/api/CollaboratorToken/GetCollaboratorToken";
    let paramsx = new HttpParams().set("UserID", UserID); //Create new HttpParams
    return this.http.get(url, { params: paramsx }).toPromise();
  }


  getUsersIDs(User) {
    var url = hostGeneral + "/api/UserAuth/GetUserIDs";
    let paramsx = new HttpParams().set("UserID", User); //Create new HttpParams
    return this.http.get(url, { params: paramsx }).toPromise();
  }

  getAuthUsersIDs(User) {
    var url = hostGeneral + "/api/UserAuth/GetAuthUserByID";
    let paramsx = new HttpParams().set("UserID", User); //Create new HttpParams
    return this.http.get(url, { params: paramsx }).toPromise();
  }


  getUserProfile(UserID) {
    var url = hostGeneral + "/api/UserProfile/GetUserProfile";
    let paramsx = new HttpParams().set("UserID", UserID); //Create new HttpParams
    //return this.http.get(url, { params: paramsx }).toPromise();
    return this.http.get(url, { headers: headers, params: paramsx }).toPromise();
  }

  saveProfile(post: any) {
    return this.http.post<any>(`${hostGeneral}/api/UserProfile/SaveProfile`, post, { headers });
  }

  changePasswordProfile(post: any) {
    //return null;
    return this.http.post<any>(`${hostGeneral}/api/UserProfile/UpdateCredentials`, post, { headers });
  }




  getUsersListByPublisher(PublisherID) {
    var url = hostGeneral + "/api/UserAuth/GetUserByPublisher";
    let paramsx = new HttpParams().set("PublisherID", PublisherID); //Create new HttpParams
    return this.http.get(url, { params: paramsx }).toPromise();
  }

  // **** 2021-10-13 JFRH: getUsersListAllAndAdmByPublisher()
  //                       Devuelve lista de usuarios con rol Publisher, Advertiser + Sysadmins para un PubliserID
  getUsersListAllAndAdmByPublisher(PublisherID) {
    var url = hostGeneral + "/api/UserAuth/GetUserAllAndAdmByPublisher";
    let paramsx = new HttpParams().set("PublisherID", PublisherID); //Create new HttpParams
    return this.http.get(url, { params: paramsx }).toPromise();
  }

  getUserListByRolID(RoleID) {

    let param = new HttpParams().set("RoleID", RoleID);
    return this.http.get(`${hostGeneral}/api/UserAuth/GetUserByRoleID`, { params: param }).toPromise();
  }

  getAdNetworkAPIUserByAdNetworkAPIID(AdNetworkAPIID) {
    let param = new HttpParams().set("AdNetworkAPIID", AdNetworkAPIID);
    return this.http.get(`${hostGeneral}/api/UserAuth/GetAdNetworkAPIUserListByAdNetwork`, { params: param }).toPromise();
  }

  getUsersListAll() {
    var url = hostGeneral + "/api/UserAuth/GetUserAll";
    return this.http.get(url, this.httpOptions2).toPromise();
  }

  getAdCompanyVerticalListByVertical(VerticalID) {
    var url = hostGeneral + "/api/AdCompanyVertical/GetCompanyVerticalByVertical";
    let paramsx = new HttpParams().set("VerticalID", VerticalID);
    return this.http.get(url, { headers: headers, params: paramsx }).toPromise();
  }

  getListAdCompanyAdFeed() {
    return this.http.get(`${hostGeneral}/api/AdCompanyAdFeed/GetListAdCompanyAdFeed`, this.httpOptions2).toPromise();
  }


  getAdConstraintTypeFilterTypeListByVertical(VerticalID) {
    var url = hostGeneral + "/api/AdConstraintTypeFilterType/GetAdConstraintTypeFilterTypeListByVertical";
    let paramsx = new HttpParams().set("VerticalID", VerticalID);
    return this.http.get(url, { headers: headers, params: paramsx }).toPromise();
  }


  getAdCompanyVerticalListByCompany(CompanyID) {
    var url = hostGeneral + "/api/AdCompanyVertical/GetCompanyVerticalByCompany";
    let paramsx = new HttpParams().set("AdCompanyID", CompanyID);
    return this.http.get(url, { headers: headers, params: paramsx }).toPromise();
  }

  getVerticalByPublisherList(PublisherID) {
    var url = hostGeneral + "/api/Verticals/GetVerticalByPublisherList";
    let paramsx = new HttpParams().set("PublisherID", PublisherID);
    return this.http.get(url, { headers: headers, params: paramsx }).toPromise();
  }

  getListVerticalByAdFeed(AdFeedID) {
    var url = hostGeneral + "/api/Verticals/GetVerticalByFeed";
    let paramsx = new HttpParams().set("AdFeedID", AdFeedID);
    return this.http.get(url, { headers: headers, params: paramsx }).toPromise();
  }


  getVerticalByCampaignUserList(UserID) {
    var url = hostGeneral + "/api/Verticals/GetVerticalByCampaignUserList";
    let paramsx = new HttpParams().set("UserID", UserID);
    return this.http.get(url, { headers: headers, params: paramsx }).toPromise();
  }


  getVerticalByAdvertiserList(AdvertiserID) {
    var url = hostGeneral + "/api/Verticals/GetVerticalByAdvertiserList";
    let paramsx = new HttpParams().set("AdCompanyID", AdvertiserID);
    return this.http.get(url, { headers: headers, params: paramsx }).toPromise();
  }

  getVerticalList() {
    //return this.http.get(`${hostGeneral}/api/Verticals/GetVerticalList`).toPromise();
    return this.http.get(`${hostGeneral}/api/Verticals/GetVerticalList`, this.httpOptions2).toPromise();
  }

  getPublisherList() {
    var urlPublisher = hostGeneral + "/api/Publishers/GetPublisherLIst";
    return this.http.get(urlPublisher, this.httpOptions2).toPromise();
  }
  getAdNetworkList() {
    var urlAdNetwork = hostGeneral + "/api/AdNetworks/GetAdNetworkList";
    return this.http.get(urlAdNetwork, this.httpOptions2).toPromise();
  }

  getAdNetworkByVertical(VerticalID) {
    var urlAdNetwork = hostGeneral + "/api/AdNetworks/GetAdNetworkByVertical";
    let paramsx = new HttpParams().set("verticalID", VerticalID); //Create new HttpParams
    return this.http.get(urlAdNetwork, { headers: headers, params: paramsx }).toPromise();
  }

  getCampaignSchedulingList() {
    var urlAdNetwork = hostGeneral + "/api/AdCampaignScheduling/GetCampaignSchedulingList";
    return this.http.get(urlAdNetwork, this.httpOptions2).toPromise();
  }

  // **** 2025-11-13 JFRH: getExternalReportApiList(): Get External Report API List
  getExternalReportApiList() {
    var url = hostGeneral + "/api/ExternalReportApi/GetExternalReportApiList";
    return this.http.get(url, this.httpOptions2).toPromise();
  }

  // **** 2025-11-20 JFRH: getExternalReportAPIParamsByExternalReportAPIID(): Get External Report API Params By ExternalReportAPIID
  getExternalReportAPIParamListByExternalReportAPIID(externalReportAPIID) {
    var url = hostGeneral + "/api/ExternalReportApi/GetExternalReportAPIParamListByExternalReportAPIID";
    let paramsx = new HttpParams().set("ExternalReportAPIID", externalReportAPIID);
    return this.http.get(url, { headers: headers, params: paramsx }).toPromise();
  }

  saveExternalReportAPIParam(post: ExternalReportAPIParam): Observable<ExternalReportAPIParam> {
    return this.http.post<ExternalReportAPIParam>(`${hostGeneral}/api/ExternalReportApi/SaveExternalReportAPIParam`, post, { headers });
  }

  deleteExternalReportAPIParam(post: ExternalReportAPIParam): Observable<ExternalReportAPIParam> {
    return this.http.post<ExternalReportAPIParam>(`${hostGeneral}/api/ExternalReportApi/DeleteExternalReportAPIParam`, post, { headers });
  }

  // **** 2025-11-20 JFRH: getExternalReportAPIResultParamMapListByExternalReportAPIID(): Get External Report API Result Params Map By ExternalReportAPIID
  getExternalReportAPIResultParamMapListByExternalReportAPIID(externalReportAPIID) {
    var url = hostGeneral + "/api/ExternalReportApi/GetExternalReportAPIResultParamMapListByExternalReportAPIID";
    let paramsx = new HttpParams().set("ExternalReportAPIID", externalReportAPIID);
    return this.http.get(url, { headers: headers, params: paramsx }).toPromise();
  }

  saveExternalReportAPIResultParamMap(post: ExternalReportAPIResultParamMap): Observable<ExternalReportAPIResultParamMap> {
    return this.http.post<ExternalReportAPIResultParamMap>(`${hostGeneral}/api/ExternalReportApi/SaveExternalReportAPIResultParamMap`, post, { headers });
  }

  deleteExternalReportAPIResultParamMap(post: ExternalReportAPIResultParamMap): Observable<ExternalReportAPIResultParamMap> {
    return this.http.post<ExternalReportAPIResultParamMap>(`${hostGeneral}/api/ExternalReportApi/DeleteExternalReportAPIResultParamMap`, post, { headers });
  }

  getCampaignSchedulingByCampaignList(AdCampaignID) {
    var url = hostGeneral + "/api/AdCampaignScheduling/GetAdCampaignSchedulingByCampaignList";
    let paramsx = new HttpParams().set("AdCampaignID", AdCampaignID); //Create new HttpParams
    return this.http.get(url, { headers: headers, params: paramsx }).toPromise();
    //return this.http.get(urlAdNetwork).toPromise();
  }



  getConsumerReportBySP(StartDate, EndDate, ShowAllState, ShowAllCreditScore, ShowAllPropertyValue, ShowAllLoanAmount,
    State, CreditScore, PropertyValueMin, PropertyValueMax, LoanAmountMin, LoanAmountMax, VerticalID, PublisherID, LandingPageID) {
    let paramsx = new HttpParams();
    var url = hostGeneral + "/api/ConsumerReport/GetConsumerReportBySP";
    paramsx = paramsx.append("State", State);
    paramsx = paramsx.append("CreditScore", CreditScore);
    paramsx = paramsx.append("PropertyValueMin", PropertyValueMin);
    paramsx = paramsx.append("PropertyValueMax", PropertyValueMax);
    paramsx = paramsx.append("LoanAmountMin", LoanAmountMin);
    paramsx = paramsx.append("LoanAmountMax", LoanAmountMax);
    paramsx = paramsx.append("StartDate", this.ReturnYMD(StartDate));
    paramsx = paramsx.append("EndDate", this.ReturnYMD(EndDate));
    paramsx = paramsx.append("ShowAllState", ShowAllState);
    paramsx = paramsx.append("ShowAllCreditScore", ShowAllCreditScore);
    paramsx = paramsx.append("ShowAllPropertyValue", ShowAllPropertyValue);
    paramsx = paramsx.append("ShowAllLoanAmount", ShowAllLoanAmount);
    paramsx = paramsx.append("VerticalID", VerticalID);
    paramsx = paramsx.append("PublisherID", PublisherID);
    paramsx = paramsx.append("LandingPageID", LandingPageID);
    paramsx = paramsx.append("Version", "2");
    return this.http.get(url, { headers: headers, params: paramsx }).toPromise();

  }

  setAdminCallReportParms(AdminCallReport: AdminCallReport) {
    let resultParams = new HttpParams()
      .set('VerticalID', AdminCallReport.VerticalID ? AdminCallReport.VerticalID.toString() : '')
      .set('AdNetworkAPIID', AdminCallReport.AdNetworkAPIID ? AdminCallReport.AdNetworkAPIID.toString() : '')
      .set('AdvertiserID', AdminCallReport.AdvertiserID ? AdminCallReport.AdvertiserID.toString() : '')
      .set('CampaignID', AdminCallReport.CampaignID ? AdminCallReport.CampaignID.toString() : '')
      .set('PublisherID', AdminCallReport.PublisherID ? AdminCallReport.PublisherID.toString() : '')
      .set('StartDate', AdminCallReport.StartDate || '')
      .set('EndDate', AdminCallReport.EndDate || '')
      .set('ShowAllVertical', AdminCallReport.ShowAllVertical ? AdminCallReport.ShowAllVertical.toString() : '')
      .set('ShowAllAdNetworkAPIID', AdminCallReport.ShowAllAdNetworkAPIID ? AdminCallReport.ShowAllAdNetworkAPIID.toString() : '')
      .set('ShowAllAdvertiser', AdminCallReport.ShowAllAdvertiser ? AdminCallReport.ShowAllAdvertiser.toString() : '')
      .set('ShowAllCampaign', AdminCallReport.ShowAllCampaign ? AdminCallReport.ShowAllCampaign.toString() : '')
      .set('ShowAllPublisher', AdminCallReport.ShowAllPublisher ? AdminCallReport.ShowAllPublisher.toString() : '')
      .set('AdUserID', AdminCallReport.AdUserID ? AdminCallReport.AdUserID.toString() : '')
      .set('RoleID', AdminCallReport.RoleID ? AdminCallReport.RoleID.toString() : '')
      .set('BillToName', AdminCallReport.BillToName || '');

    return resultParams;
  }

  getAdminCallReport(AdminCallReport: AdminCallReport) {
    const urlToRequest = `${hostGeneral}/api/AdminCallReport/GetAdminCallreport`;
    const parameters = this.setAdminCallReportParms(AdminCallReport);

    return this.http.get<AdminCallReport>(urlToRequest, { headers: headers, params: parameters });
  }

  getAdminCallReport$(AdminCallReport: AdminCallReport, cancel$: Observable<void> // To receive cancellation signal
  ): Observable<AdminCallReport> {
    const urlToRequest = `${hostGeneral}/api/AdminCallReport/GetAdminCallreport`;
    const parameters = this.setAdminCallReportParms(AdminCallReport);

    return this.http
    .get<AdminCallReport>(urlToRequest, { headers, params: parameters })
    .pipe(takeUntil(cancel$));
  }

  getRecordingCallLog(AdminCallReport: AdminCallReport) {
    const urlToRequest = `${hostGeneral}/api/AdminCallReport/GetRecordingCallLog`;
    const parameters = this.setAdminCallReportParms(AdminCallReport);

    return this.http.get<AdminCallReport>(urlToRequest, { headers: headers, params: parameters });
  }

  getDataAdminReportBySP(VerticalID, AdNetworkAPIID, AdvertiserID, CampaignID, PublisherID, StartDate, EndDate,
    ShowAllVertical, ShowAllAdNetworkAPIID, ShowAllAdvertiser, ShowAllCampaign, ShowAllPublisher, UserID, RoleID, BrandName, ShowAllBrandName, landingPageID, showAllLandingPages,
    groupByMonth, SourceID, ShowAllSourceIDs) {
    let paramsx = new HttpParams();
    var urlAdNetwork = hostGeneral + "/api/AdminReport/GetAdminReportBySP";
    paramsx = paramsx.append("VerticalID", VerticalID);
    paramsx = paramsx.append("AdNetworkAPIID", AdNetworkAPIID);
    paramsx = paramsx.append("AdvertiserID", AdvertiserID);
    paramsx = paramsx.append("CampaignID", CampaignID);
    paramsx = paramsx.append("PublisherID", PublisherID);
    paramsx = paramsx.append("StartDate", this.ReturnYMD(StartDate));
    paramsx = paramsx.append("EndDate", this.ReturnYMD(EndDate));
    paramsx = paramsx.append("ShowAllVertical", ShowAllVertical);
    paramsx = paramsx.append("ShowAllAdNetworkAPIID", ShowAllAdNetworkAPIID);
    paramsx = paramsx.append("ShowAllAdvertiser", ShowAllAdvertiser);
    paramsx = paramsx.append("ShowAllCampaign", ShowAllCampaign);
    paramsx = paramsx.append("ShowAllPublisher", ShowAllPublisher);
    paramsx = paramsx.append("AdUserID", UserID);
    paramsx = paramsx.append("RoleID", RoleID);
    paramsx = paramsx.append("BrandName", BrandName);
    paramsx = paramsx.append("ShowAllBrandName", ShowAllBrandName);
    paramsx = paramsx.append("LandingPageID", landingPageID);
    paramsx = paramsx.append("ShowAllLandingPages", showAllLandingPages);
    paramsx = paramsx.append("GroupByMonth", groupByMonth);
    paramsx = paramsx.append("SourceID", SourceID);
    paramsx = paramsx.append("ShowAllSourceIDs", ShowAllSourceIDs);
    paramsx = paramsx.append("Version", "2");
    return this.http.get(urlAdNetwork, { headers: headers, params: paramsx }).toPromise();
  }

  // **** 2025-12-02 JBDCR: Observable version to be able to cancel the HTTP request
  getDataAdminReportBySP$(VerticalID, AdNetworkAPIID, AdvertiserID, CampaignID, PublisherID, StartDate, EndDate,
    ShowAllVertical, ShowAllAdNetworkAPIID, ShowAllAdvertiser, ShowAllCampaign, ShowAllPublisher, UserID, RoleID, BrandName, ShowAllBrandName, landingPageID, showAllLandingPages,
    groupByMonth, SourceID, ShowAllSourceIDs, cancel$: Observable<void> // To receive cancellation signal
  ): Observable<any> {
    let paramsx = new HttpParams();
    const urlAdNetwork = hostGeneral + '/api/AdminReport/GetAdminReportBySP';

    paramsx = paramsx.append("VerticalID", VerticalID);
    paramsx = paramsx.append("AdNetworkAPIID", AdNetworkAPIID);
    paramsx = paramsx.append("AdvertiserID", AdvertiserID);
    paramsx = paramsx.append("CampaignID", CampaignID);
    paramsx = paramsx.append("PublisherID", PublisherID);
    paramsx = paramsx.append("StartDate", this.ReturnYMD(StartDate));
    paramsx = paramsx.append("EndDate", this.ReturnYMD(EndDate));
    paramsx = paramsx.append("ShowAllVertical", ShowAllVertical);
    paramsx = paramsx.append("ShowAllAdNetworkAPIID", ShowAllAdNetworkAPIID);
    paramsx = paramsx.append("ShowAllAdvertiser", ShowAllAdvertiser);
    paramsx = paramsx.append("ShowAllCampaign", ShowAllCampaign);
    paramsx = paramsx.append("ShowAllPublisher", ShowAllPublisher);
    paramsx = paramsx.append("AdUserID", UserID);
    paramsx = paramsx.append("RoleID", RoleID);
    paramsx = paramsx.append("BrandName", BrandName);
    paramsx = paramsx.append("ShowAllBrandName", ShowAllBrandName);
    paramsx = paramsx.append("LandingPageID", landingPageID);
    paramsx = paramsx.append("ShowAllLandingPages", showAllLandingPages);
    paramsx = paramsx.append("GroupByMonth", groupByMonth);
    paramsx = paramsx.append("SourceID", SourceID);
    paramsx = paramsx.append("ShowAllSourceIDs", ShowAllSourceIDs);
    paramsx = paramsx.append("Version", "2");

    return this.http.get<any>(urlAdNetwork, { headers, params: paramsx }).pipe(
      takeUntil(cancel$) // This cancels the request when cancel$ is emitted
    );
  }

  // **** 2022-01-28 JFRH: getDataAdminReportTotalImpressionsBySP(): Llama a SP [GetAdminReportTotalImpressions] para totales de AvailableImpressions e Impressions por VerticalID, External AdNetworkAPIID y Brand Name
  getDataAdminReportTotalImpressionsBySP(VerticalID, AdNetworkAPIID, BrandName, StartDate, EndDate, PublisherID, UserID, RoleID) {
    let paramsx = new HttpParams();
    var urlAdNetwork = hostGeneral + "/api/AdminReport/GetAdminReportTotalImpressionsBySP";
    paramsx = paramsx.append("VerticalID", VerticalID);
    paramsx = paramsx.append("AdNetworkAPIID", AdNetworkAPIID);
    paramsx = paramsx.append("BrandName", BrandName);
    paramsx = paramsx.append("StartDate", this.ReturnYMD(StartDate));
    paramsx = paramsx.append("EndDate", this.ReturnYMD(EndDate));
    paramsx = paramsx.append("PublisherID", PublisherID);
    paramsx = paramsx.append("UserID", UserID);
    paramsx = paramsx.append("RoleID", RoleID);
    return this.http.get(urlAdNetwork, { headers: headers, params: paramsx }).toPromise();

  }

  getBrandNameListByAdNetworkAPIIDVerticalID(AdNetworkAPIID, VerticalID) {
    var urlLP = hostGeneral + "/api/AdminReport/GetBrandNameByAdNetworkAPIIDBySP";
    let paramsx = new HttpParams();
    paramsx = paramsx.append("AdNetworkAPIID", AdNetworkAPIID);
    paramsx = paramsx.append("verticalID", VerticalID);
    return this.http.get(urlLP, { headers: headers, params: paramsx }).toPromise();

  }

  getCollaboratorCampaign(VerticalID, AdNetworkAPIID, AdvertiserID, CampaignID,
    ShowAllVertical, ShowAllAdNetworkAPIID, ShowAllAdvertiser, ShowAllCampaign) {
    let paramsx = new HttpParams();
    var urlAdNetwork = hostGeneral + "/api/CollaboratorCampaignReport/GetCollaboratorCampaignReport";
    paramsx = paramsx.append("VerticalID", VerticalID);
    paramsx = paramsx.append("AdNetworkAPIID", AdNetworkAPIID);
    paramsx = paramsx.append("AdvertiserID", AdvertiserID);
    paramsx = paramsx.append("CampaignID", CampaignID);
    paramsx = paramsx.append("ShowAllVertical", ShowAllVertical);
    paramsx = paramsx.append("ShowAllAdNetworkAPIID", ShowAllAdNetworkAPIID);
    paramsx = paramsx.append("ShowAllAdvertiser", ShowAllAdvertiser);
    paramsx = paramsx.append("ShowAllCampaign", ShowAllCampaign);
    paramsx = paramsx.append("Version", "2");
    return this.http.get(urlAdNetwork, { headers: headers, params: paramsx }).toPromise();

  }

  getDataEndReport(ReportType, VerticalID, PublisherID, AdNetworkAPIID, StartDate, EndDate, UserID, RoleID, ShowAllVertical) {
    let paramsx = new HttpParams();
    var urlEndPoint = hostGeneral + "/api/AdminReport/GetAdminReportEndMonth";
    paramsx = paramsx.append("ReportType", ReportType);
    paramsx = paramsx.append("VerticalID", VerticalID);
    paramsx = paramsx.append("PublisherID", PublisherID);
    paramsx = paramsx.append("AdNetworkAPIID", AdNetworkAPIID);
    paramsx = paramsx.append("StartDate", this.ReturnYMD(StartDate));
    paramsx = paramsx.append("EndDate", this.ReturnYMD(EndDate));
    paramsx = paramsx.append("ShowAllVertical", ShowAllVertical);
    paramsx = paramsx.append("AdUserID", UserID);
    paramsx = paramsx.append("RoleID", RoleID);
    return this.http.get(urlEndPoint, { headers: headers, params: paramsx }).toPromise();

  }

  getArcherData() {
    let paramsx = new HttpParams();
    var urlEndPoint = hostGeneral + "/api/AdCampaign/GetArcherReport";
    return this.http.get(urlEndPoint, { headers: headers, params: paramsx }).toPromise();

  }



  getDataLeadAdminReportBySP(VerticalID, AdNetworkAPIID, landingPageID, AdvertiserID, CampaignID, PublisherID, StartDate, EndDate,
    ShowAllVertical, ShowAllAdNetworkAPIID, showAllLandingPages, ShowAllAdvertiser, ShowAllCampaign, ShowAllPublisher, UserID, RoleID) {
    let paramsx = new HttpParams();
    var urlAdNetwork = hostGeneral + "/api/LeadAdminReport/GetLeadAdminReportBySP";
    paramsx = paramsx.append("VerticalID", VerticalID);
    paramsx = paramsx.append("AdNetworkAPIID", AdNetworkAPIID);
    paramsx = paramsx.append("AdvertiserID", AdvertiserID);
    paramsx = paramsx.append("CampaignID", CampaignID);
    paramsx = paramsx.append("PublisherID", PublisherID);
    paramsx = paramsx.append("StartDate", this.ReturnYMD(StartDate));
    paramsx = paramsx.append("EndDate", this.ReturnYMD(EndDate));
    paramsx = paramsx.append("ShowAllVertical", ShowAllVertical);
    paramsx = paramsx.append("ShowAllAdNetworkAPIID", ShowAllAdNetworkAPIID);
    paramsx = paramsx.append("ShowAllAdvertiser", ShowAllAdvertiser);
    paramsx = paramsx.append("ShowAllCampaign", ShowAllCampaign);
    paramsx = paramsx.append("LandingPageID", landingPageID);
    paramsx = paramsx.append("ShowAllLandingPages", showAllLandingPages);
    paramsx = paramsx.append("ShowAllPublisher", ShowAllPublisher);
    paramsx = paramsx.append("AdUserID", UserID);
    paramsx = paramsx.append("RoleID", RoleID);
    paramsx = paramsx.append("Version", "2");
    return this.http.get(urlAdNetwork, { headers: headers, params: paramsx }).toPromise();
  }

  getDataLeadAdminReportBySP$(VerticalID, AdNetworkAPIID, landingPageID, AdvertiserID, CampaignID, PublisherID, StartDate, EndDate,
    ShowAllVertical, ShowAllAdNetworkAPIID, showAllLandingPages, ShowAllAdvertiser, ShowAllCampaign, ShowAllPublisher, UserID, RoleID, cancel$: Observable<void>
  ): Observable<any> {
    let paramsx = new HttpParams();
    var urlAdNetwork = hostGeneral + "/api/LeadAdminReport/GetLeadAdminReportBySP";
    paramsx = paramsx.append("VerticalID", VerticalID);
    paramsx = paramsx.append("AdNetworkAPIID", AdNetworkAPIID);
    paramsx = paramsx.append("AdvertiserID", AdvertiserID);
    paramsx = paramsx.append("CampaignID", CampaignID);
    paramsx = paramsx.append("PublisherID", PublisherID);
    paramsx = paramsx.append("StartDate", this.ReturnYMD(StartDate));
    paramsx = paramsx.append("EndDate", this.ReturnYMD(EndDate));
    paramsx = paramsx.append("ShowAllVertical", ShowAllVertical);
    paramsx = paramsx.append("ShowAllAdNetworkAPIID", ShowAllAdNetworkAPIID);
    paramsx = paramsx.append("ShowAllAdvertiser", ShowAllAdvertiser);
    paramsx = paramsx.append("ShowAllCampaign", ShowAllCampaign);
    paramsx = paramsx.append("LandingPageID", landingPageID);
    paramsx = paramsx.append("ShowAllLandingPages", showAllLandingPages);
    paramsx = paramsx.append("ShowAllPublisher", ShowAllPublisher);
    paramsx = paramsx.append("AdUserID", UserID);
    paramsx = paramsx.append("RoleID", RoleID);
    paramsx = paramsx.append("Version", "2");
    return this.http.get<any>(urlAdNetwork, { headers, params: paramsx }).pipe(
      takeUntil(cancel$) // This cancels the request when cancel$ is emitted
    );
  }

  getDataAdminReportTotalsBySP(VerticalID, PublisherID, ShowAllVertical, StartDate, EndDate) {
    let paramsx = new HttpParams();
    var urlAdNetwork = hostGeneral + "/api/AdminReport/GetAdminReportBySPTotal";
    paramsx = paramsx.append("VerticalID", VerticalID);
    paramsx = paramsx.append("PublisherID", PublisherID);
    paramsx = paramsx.append("ShowAllVertical", ShowAllVertical);
    paramsx = paramsx.append("StartDate", this.ReturnYMD(StartDate));
    paramsx = paramsx.append("EndDate", this.ReturnYMD(EndDate));
    return this.http.get(urlAdNetwork, { headers: headers, params: paramsx }).toPromise();

  }



  getDataLTReportBySP(CampaignID, StartDate, EndDate, ShowAllCampaign) {
    let paramsx = new HttpParams();
    var url = hostGeneral + "/api/LTReport/GetLTReportBySP";
    paramsx = paramsx.append("CampaignID", CampaignID);
    paramsx = paramsx.append("StartDate", this.ReturnYMD(StartDate));
    paramsx = paramsx.append("EndDate", this.ReturnYMD(EndDate));
    paramsx = paramsx.append("ShowAllCampaign", ShowAllCampaign);
    return this.http.get(url, { headers: headers, params: paramsx }).toPromise();

  }

  getAdCampaignURLDynamic(AdCampaignID) {
    let paramsx = new HttpParams();
    var url = hostGeneral + "/api/AdCampaignURLDynamicValues/GetURLDynamicsByCampaign";
    paramsx = paramsx.append("AdCampaignID", AdCampaignID);
    return this.http.get(url, { headers: headers, params: paramsx }).toPromise();

  }

  getDataAdminReportBySPAdvertiser(VerticalID, AdNetworkAPIID, AdvertiserID, CampaignID, PublisherID, StartDate, EndDate,
    ShowAllVertical, ShowAllAdNetworkAPIID, ShowAllAdvertiser, ShowAllCampaign, ShowAllPublisher, AdUserID, RoleID) {
    let paramsx = new HttpParams();
    var urlAdNetwork = hostGeneral + "/api/AdminReport/GetAdminReportBySPAdvertiserV2";
    paramsx = paramsx.append("VerticalID", VerticalID);
    paramsx = paramsx.append("AdNetworkAPIID", AdNetworkAPIID);
    paramsx = paramsx.append("AdvertiserID", AdvertiserID);
    paramsx = paramsx.append("CampaignID", CampaignID);
    paramsx = paramsx.append("PublisherID", PublisherID);
    paramsx = paramsx.append("StartDate", this.ReturnYMD(StartDate));
    paramsx = paramsx.append("EndDate", this.ReturnYMD(EndDate));
    paramsx = paramsx.append("ShowAllVertical", ShowAllVertical);
    paramsx = paramsx.append("ShowAllAdNetworkAPIID", ShowAllAdNetworkAPIID);
    paramsx = paramsx.append("ShowAllAdvertiser", ShowAllAdvertiser);
    paramsx = paramsx.append("ShowAllCampaign", ShowAllCampaign);
    paramsx = paramsx.append("ShowAllPublisher", ShowAllPublisher);
    paramsx = paramsx.append("AdUserID", AdUserID);
    paramsx = paramsx.append("RoleID", RoleID);
    paramsx = paramsx.append("Version", "2");
    return this.http.get(urlAdNetwork, { headers: headers, params: paramsx }).toPromise();
  }

  getDataAdminReportBySPAdvertiser$(VerticalID, AdNetworkAPIID, AdvertiserID, CampaignID, PublisherID, StartDate, EndDate,
    ShowAllVertical, ShowAllAdNetworkAPIID, ShowAllAdvertiser, ShowAllCampaign, ShowAllPublisher, AdUserID, RoleID, cancel$: Observable<void>): Observable<any> {
    let paramsx = new HttpParams();
    var urlAdNetwork = hostGeneral + "/api/AdminReport/GetAdminReportBySPAdvertiserV2";
    paramsx = paramsx.append("VerticalID", VerticalID);
    paramsx = paramsx.append("AdNetworkAPIID", AdNetworkAPIID);
    paramsx = paramsx.append("AdvertiserID", AdvertiserID);
    paramsx = paramsx.append("CampaignID", CampaignID);
    paramsx = paramsx.append("PublisherID", PublisherID);
    paramsx = paramsx.append("StartDate", this.ReturnYMD(StartDate));
    paramsx = paramsx.append("EndDate", this.ReturnYMD(EndDate));
    paramsx = paramsx.append("ShowAllVertical", ShowAllVertical);
    paramsx = paramsx.append("ShowAllAdNetworkAPIID", ShowAllAdNetworkAPIID);
    paramsx = paramsx.append("ShowAllAdvertiser", ShowAllAdvertiser);
    paramsx = paramsx.append("ShowAllCampaign", ShowAllCampaign);
    paramsx = paramsx.append("ShowAllPublisher", ShowAllPublisher);
    paramsx = paramsx.append("AdUserID", AdUserID);
    paramsx = paramsx.append("RoleID", RoleID);
    paramsx = paramsx.append("Version", "2");
    return this.http.get<any>(urlAdNetwork, { headers, params: paramsx }).pipe(
      takeUntil(cancel$) // This cancels the request when cancel$ is emitted
    );
  }

  getBudgetManagementByAdvertiser(VerticalID, AdNetworkAPIID, AdvertiserID, CampaignID, PublisherID, StartDate, EndDate,
    ShowAllVertical, ShowAllAdNetworkAPIID, ShowAllAdvertiser, ShowAllCampaign, ShowAllPublisher, AdUserID, RoleID, SelectedDate, SourceID,
    ShowAllSourceIDs) {
    let paramsx = new HttpParams();
    var urlAdNetwork = hostGeneral + "/api/AdminReport/GetBudgetManagementByAdvertiser";
    paramsx = paramsx.append("VerticalID", VerticalID);
    paramsx = paramsx.append("AdNetworkAPIID", AdNetworkAPIID);
    paramsx = paramsx.append("AdvertiserID", AdvertiserID);
    paramsx = paramsx.append("CampaignID", CampaignID);
    paramsx = paramsx.append("PublisherID", PublisherID);
    paramsx = paramsx.append("StartDate", this.ReturnYMD(StartDate));
    paramsx = paramsx.append("EndDate", this.ReturnYMD(EndDate));
    paramsx = paramsx.append("ShowAllVertical", ShowAllVertical);
    paramsx = paramsx.append("ShowAllAdNetworkAPIID", ShowAllAdNetworkAPIID);
    paramsx = paramsx.append("ShowAllAdvertiser", ShowAllAdvertiser);
    paramsx = paramsx.append("ShowAllCampaign", ShowAllCampaign);
    paramsx = paramsx.append("ShowAllPublisher", ShowAllPublisher);
    paramsx = paramsx.append("AdUserID", AdUserID);
    paramsx = paramsx.append("RoleID", RoleID);
    paramsx = paramsx.append("Version", "2");
    paramsx = paramsx.append("SelectedDate", SelectedDate);
    paramsx = paramsx.append("SourceID", SourceID);
    paramsx = paramsx.append("ShowAllSourceIDs", ShowAllSourceIDs);

    return this.http.get(urlAdNetwork, { headers: headers, params: paramsx }).toPromise();

  }

  getAdNetworkApiList() {
    var urlAdNetwork = hostGeneral + "/api/AdNetworkAPI/GetAdNetworkAPIList";
    return this.http.get(urlAdNetwork, this.httpOptions2).toPromise();
  }

  GetAdNetworkAPIParamTypeList() {
    var urlAdNetwork = hostGeneral + "/api/AdNetworkAPIParamType/GetAdNetworkAPIParamTypeList";
    return this.http.get(urlAdNetwork, this.httpOptions2).toPromise();
  }


  getAdNetworkAPIListByVertical(pVerticalID) {
    var urlAdNetwork = hostGeneral + "/api/AdNetworkAPI/GetAdNetworkAPIListByVertical";
    let paramsx = new HttpParams().set("VerticalID", pVerticalID); //Create new HttpParams
    return this.http.get(urlAdNetwork, { headers: headers, params: paramsx }).toPromise();
  }

  getAdNetworkAPIListByVerticalByPublisher(pVerticalID, pPublisherID, pAdUserID) {
    var urlAdNetwork = hostGeneral + "/api/AdNetworkAPI/GetAdNetworkAPIListByVerticalByPublisher";
    let paramsx = new HttpParams();
    paramsx = paramsx.append("VerticalID", pVerticalID);
    paramsx = paramsx.append("PublisherID", pPublisherID);
    paramsx = paramsx.append("AdUserID", pAdUserID);
    return this.http.get(urlAdNetwork, { headers: headers, params: paramsx }).toPromise();
  }

  getAdNetworkAPIListByVerticalByUser(pVerticalID, pAdUserID) {
    var urlAdNetwork = hostGeneral + "/api/AdNetworkAPI/GetAdNetworkAPIListByVerticalByUser";
    let paramsx = new HttpParams();
    paramsx = paramsx.append("VerticalID", pVerticalID);
    paramsx = paramsx.append("AdUserID", pAdUserID);
    return this.http.get(urlAdNetwork, { headers: headers, params: paramsx }).toPromise();
  }

  getAdNetworkApiListByAdNetwork(pNetworkID) {
    var urlAdNetwork = hostGeneral + "/api/AdNetworkAPI/GetAdNetworkAPIListByAdNetwork";
    //let params = new HttpParams().set("NetworkID",pNetworkID).set("paramName2", paramValue2); //Create new HttpParams
    let paramsx = new HttpParams().set("adNetID", pNetworkID); //Create new HttpParams

    return this.http.get(urlAdNetwork, { headers: headers, params: paramsx }).toPromise();
  }


  getAdNetworkApiListByLanding(pLandingID) {
    var urlAdNetApi = hostGeneral + "/api/AdNetworkAPI/GetAdNetworkAPIByLanding";
    let paramsx = new HttpParams().set("LandingID", pLandingID); //Create new HttpParams
    return this.http.get(urlAdNetApi, { headers: headers, params: paramsx }).toPromise();
  }


  getLandingPageAdNetworkAPIListByLandingPageAdNetworkParam(pLandingPageAdNetworkParamID) {
    var urlAdNetApi = hostGeneral + "/api/LandingPageAdNetworkParamMapValue/GetLandingPageAdNetworkAPIListByLandingPageAdNetworkParam";
    let paramsx = new HttpParams().set("LandingPageAdNetworkParamID", pLandingPageAdNetworkParamID);
    return this.http.get(urlAdNetApi, { headers: headers, params: paramsx }).toPromise();
  }

  getLandingPageAdFeedParamMapValueListByLandingPageAdFeedParam(LandingPageAdFeedParamID) {
    var urlAdNetApi = hostGeneral + "/api/LandingPageAdFeedParamMapValue/GetLandingPageAdFeedParamMapValueList";
    let paramsx = new HttpParams().set("LandingPageAdFeedParamID", LandingPageAdFeedParamID);
    return this.http.get(urlAdNetApi, { headers: headers, params: paramsx }).toPromise();
  }

  //LandingPageAdNetworkParamMapValue


  getAdNetworkAPIByID(pAdNetworkAPIID) {
    var urlAdNetwork = hostGeneral + "/api/AdNetworkAPI/GetAdNetworkAPIByAdNetwork";
    let paramsx = new HttpParams().set("AdNetworkAPIID", pAdNetworkAPIID); //Create new HttpParams

    return this.http.get(urlAdNetwork, { headers: headers, params: paramsx }).toPromise();
  }

  getAdNetworkAPIParamsByAdNetAPI(AdNetwokAPIID) {
    var urlAdNetwork = hostGeneral + "/api/AdNetworkAPIParam/GetAdNetworkAPIParamListByAdNetworkAPI";
    let paramsx = new HttpParams().set("AdNewtworkAPIID", AdNetwokAPIID); //Create new HttpParams
    return this.http.get(urlAdNetwork, { headers: headers, params: paramsx }).toPromise();

  }


  getAdNetworkAPIParamByParamaID(AdNetworkAPIParamID) {
    var url = hostGeneral + "/api/LandingPageAdNetworkParam/GetLandingPageAdNetworkParamByParamID";
    let paramsx = new HttpParams().set("AdNetworkAPIParamID", AdNetworkAPIParamID); //Create new HttpParams
    return this.http.get(url, { headers: headers, params: paramsx }).toPromise();
  }

  getAdNetworkAPIParamByParamaIDByLanding(AdNetworkAPIParamID, LandingPageID) {
    var url = hostGeneral + "/api/LandingPageAdNetworkParam/GetLandingPageAdNetworkParamByParamIDByLanding";
    let paramsx = new HttpParams();
    paramsx = paramsx.append("AdNetworkAPIParamID", AdNetworkAPIParamID);
    paramsx = paramsx.append("LandingPageID", LandingPageID);

    return this.http.get(url, { headers: headers, params: paramsx }).toPromise();
  }

  // **** 2022-07-26 JFRH: getLandingPageAdNetworkParamListByLandingPage(), llamada a GetLandingPageAdNetworkAPIListByLanding()
  getLandingPageAdNetworkParamListByLandingPage(pLandingPageID) {
    var urlAdNetApi = hostGeneral + "/api/LandingPageAdNetworkParam/GetLandingPageAdNetworkAPIListByLanding";
    let paramsx = new HttpParams().set("LandingPageID", pLandingPageID);
    return this.http.get(urlAdNetApi, { headers: headers, params: paramsx }).toPromise();
  }

  getAdNetworkAPIResultFieldListByAPI(AdNetApiID) {
    var urlAdNetAPIResult = hostGeneral + "/api/AdNetworkAPIResultField/GetAdNetworkAPIResultFieldListByAPI";
    let paramsx = new HttpParams().set("ApiID", AdNetApiID);
    return this.http.get(urlAdNetAPIResult, { headers: headers, params: paramsx }).toPromise();

  }

  getLandingPageAdNetworkAPIByLanding(LandingID) {
    var urlApi = hostGeneral + "/api/LandingPageAdNetworkAPI/GetLandingPageAdNetworkByLandingList";
    let paramsx = new HttpParams().set("LandingPageID", LandingID);
    return this.http.get(urlApi, { headers: headers, params: paramsx }).toPromise();

  }

  getLandingPageAdFeedByLanding(LandingID) {
    var urlApi = hostGeneral + "/api/LandingPageAdFeed/GetLandingPageAdFeedByLandingList";
    let paramsx = new HttpParams().set("LandingPageID", LandingID);
    return this.http.get(urlApi, { headers: headers, params: paramsx }).toPromise();

  }

  getLandingPageListByAdNetworkAPIID(adNetworkAPIID) {
    var urlToRequest = hostGeneral + "/api/LandingPage/GetLandingPageByAdNetworkAPIID";
    let paramsx = new HttpParams().set("AdNetworkAPIID", adNetworkAPIID);
    return this.http.get(urlToRequest, { headers: headers, params: paramsx });
  }


  GetLandingPageAdFeedParamByLandingPageAdFeedID(AdFeedID) {
    var urlAdNetwork = hostGeneral + "/api/LandingPageAdFeedParam/GetLandingPageAdFeedParamByLandingPageAdFeedID";
    let paramsx = new HttpParams().set("AdFeedID", AdFeedID); //Create new HttpParams
    return this.http.get(urlAdNetwork, { headers: headers, params: paramsx }).toPromise();
  }

  //getAdNetworkAPIParamByParamaIDByLanding(AdNetworkAPIParamID, LandingPageID) {
  getAdFeedParamByParamaIDByLanding(LandingPageAdFeedParamID, LandingPageID) {
    var url = hostGeneral + "/api/LandingPageAdFeedParam/GetLandingPageAdFeedParamByParamIDByLanding";
    let paramsx = new HttpParams();
    paramsx = paramsx.append("LandingPageAdFeedParamID", LandingPageAdFeedParamID);
    paramsx = paramsx.append("LandingPageID", LandingPageID);

    return this.http.get(url, { headers: headers, params: paramsx }).toPromise();
  }

  getLandingPageAdFeedParamByLandingFeedConstraint(AdFeedID, LandingPageID, AdConstraintTypeID) {
    var url = hostGeneral + "/api/LandingPageAdFeedParam/GetLandingPageAdFeedParamByLandingFeedConstraint";
    let paramsx = new HttpParams();
    paramsx = paramsx.append("AdFeedID", AdFeedID);
    paramsx = paramsx.append("LandingPageID", LandingPageID);
    paramsx = paramsx.append("AdConstraintTypeID", AdConstraintTypeID);

    return this.http.get(url, { headers: headers, params: paramsx }).toPromise();
  }


  getLandingPageList() {
    var urlLP = hostGeneral + "/api/LandingPage/GetLandingPageList";
    return this.http.get(urlLP, this.httpOptions2).toPromise();
  }

  /**
   * Description: Function to save margin & bid modifier percentage values
   * @param percentageValue BidModifier or Margin percentage value
   * @param typeOfValue 1 => Margin | 2 => BidModifier
   * @param landingPageID Landing page ID
   * @returns Observable
   */
  SaveLandingPageMarginAndBidModValue(percentageValue, typeOfValue, landingPageID) {
    var urlToRequest = `${hostGeneral}/api/LandingPage/SaveLandingPageMarginAndBidModValue`;

    let parameters = new HttpParams();
    parameters = parameters.append('PercentageValue', percentageValue);
    parameters = parameters.append('TypeOfValue', typeOfValue);
    parameters = parameters.append('LandingPageID', landingPageID);

    return this.http.post(urlToRequest, {
      PercentageValue: percentageValue,
      TypeOfValue: typeOfValue,
      LandingPageID: landingPageID
    }, {
      headers: headers,
      params: parameters
    });

  }



  getLandingAdNetworkByLanding(pLangingPageID) {
    var urlmr = hostGeneral + "/api/LandingPage/GetLandingPageAdNetByLanding";
    let paramsx = new HttpParams().set("LandingPageID", pLangingPageID); //Create new HttpParams
    return this.http.get(urlmr, { headers: headers, params: paramsx }).toPromise();
  }

  getMenuByUser(UserID) {
    //this.SetHeadersToken();
    var url = hostGeneral + "/api/Menu/GetMenuListByUser";

    let paramsx = new HttpParams();
    paramsx = paramsx.append("UserID", UserID);
    return this.http.get(url, { headers: headers, params: paramsx }).toPromise();
  }

  getMenuByUser_SP(UserID) {
    //this.SetHeadersToken();
    var url = hostGeneral + "/api/Menu/GetMenuListByUser_SP";

    let paramsx = new HttpParams();
    paramsx = paramsx.append("UserID", UserID);
    return this.http.get(url, { headers: headers, params: paramsx }).toPromise();
  }

  getMenuList() {
    var urlLP = hostGeneral + "/api/Menu/GetMenuList";
    return this.http.get(urlLP, this.httpOptions2).toPromise();
  }
  getRolList() {
    var urlLP = hostGeneral + "/api/Rol/GetRolList";
    return this.http.get(urlLP, this.httpOptions2).toPromise();
  }
  getRolTypeList() {
    var urlLP = hostGeneral + "/api/RolType/GetRolTypeList";
    return this.http.get(urlLP, this.httpOptions2).toPromise();
  }


  getMenuRolList() {
    var urlLP = hostGeneral + "/api/MenuRol/GetMenuRolList";
    return this.http.get(urlLP, this.httpOptions2).toPromise();
    //return this.http.get(urlLP).toPromise();
  }
  getMenuRolListByCompany(pCompanyID) {
    var urlmr = hostGeneral + "/api/MenuRol/GetMenuRolListByCompany";
    let paramsx = new HttpParams().set("CompanyID", pCompanyID); //Create new HttpParams
    return this.http.get(urlmr, { headers: headers, params: paramsx }).toPromise();
  }


  getLandingPageListByVertical(pVerticalID) {
    var urlLP = hostGeneral + "/api/LandingPage/GetLandignPageListByVertical";
    let paramsx = new HttpParams().set("VerticalID", pVerticalID); //Create new HttpParams
    return this.http.get(urlLP, { headers: headers, params: paramsx }).toPromise();
  }

  getLandingPageListByPublisher(pPublisherID) {
    var urlLP = hostGeneral + "/api/LandingPage/GetLandignPageListByPublisher";
    let paramsx = new HttpParams().set("PublisherID", pPublisherID); //Create new HttpParams
    return this.http.get(urlLP, { headers: headers, params: paramsx }).toPromise();
  }

  getLandingPageListByPublisherID(pPublisherID) {
    var urlLP = hostGeneral + "/api/LandingPage/GetLandingPageListByPublisherID";
    let paramsx = new HttpParams().set("PublisherID", pPublisherID); //Create new HttpParams
    return this.http.get(urlLP, { headers: headers, params: paramsx }).toPromise();
  }

  getLandingPageListByPublisherAndVertical(pPublisherID, pVerticalID) {
    var urlLP = hostGeneral + "/api/LandingPage/GetLandingPageListByPublisherAndVertical";
    let paramsx = new HttpParams();
    paramsx = paramsx.append("PublisherID", pPublisherID);
    paramsx = paramsx.append("VerticalID", pVerticalID);
    return this.http.get(urlLP, { headers: headers, params: paramsx }).toPromise();
  }

  getLandingListByAdFeedID(adFeedID: string) {
    const urlToRequest = `${hostGeneral}/api/LandingPage/GetLandingListByAdFeedID`;

    let params = new HttpParams();
    params = params.append("AdFeedID", adFeedID);

    return this.http.get(urlToRequest, { headers: headers, params: params });
  }


  getDataList(post: TableGeneral): Observable<TableGeneral> {
    return this.http.post<any>(`${hostGeneral}/api/General/GetDataStr`, post, httpOptions);
  }


  getDataBySPList(post: any) {
    var url = hostGeneral + "/api/General/GetDataBySP";
    let paramsx = new HttpParams();
    paramsx = paramsx.append("SpName", post.SpName);
    paramsx = paramsx.append("Parametros", post.Parametros);
    return this.http.get(url, { headers: headers, params: paramsx }).toPromise();
    //return this.http.post<any>(`${hostGeneral}/api/General/GetDataBySP`, post, httpOptions);
  }

  getAdvertiserReportList() {
    var urlLP = hostGeneral + "/api/AdvertiserReport/GetAdvertiserReportList";
    return this.http.get(urlLP, this.httpOptions2).toPromise();
  }

  ReturnYMD = function (today) {
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();

    if (dd < 10) {
      dd = '0' + dd
    }

    if (mm < 10) {
      mm = '0' + mm
    }

    //today = mm + '/' + dd + '/' + yyyy;
    today = yyyy + '/' + mm + '/' + dd;

    return today;

  }

  copyMessage(val: string) {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
  }

  uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }



  fnCreateUIICampaign(CampaignID) {
    var str = this.uuidv4();
    //document.getElementById("original").innerHTML = str;
    var CountTotal = str.length; //36
    var FBlockStr = str.substring(0, str.indexOf("-")); //5a7939fd
    var CountFBlock = FBlockStr.length; //8
    var position = CountTotal - CountFBlock; //(36-8) = 28
    var output = [str.slice(0, CountFBlock), CampaignID, str.slice(CountFBlock)].join('');
    return output;
  }

  fnGetCampaignFromUII(CampaignIDSTR) {
    var str = CampaignIDSTR;
    var FBlockStr = str.substring(0, str.indexOf("-")); //5a7939fd
    var CountFBlock = FBlockStr.length; //8
    var CampaignID = FBlockStr.substring(CountFBlock - 3, str.length);
    return CampaignID;
  }


  getAdminReportByVertical(VerticalID, StartDate, EndDate) {
    var urlLP = hostGeneral + "/api/AdminReport/GetAdminReportByVertical";
    let paramsx = new HttpParams();
    paramsx = paramsx.append("VerticalID", VerticalID);
    paramsx = paramsx.append("StartDate", this.ReturnYMD(StartDate));
    paramsx = paramsx.append("EndDate", this.ReturnYMD(EndDate));
    return this.http.get(urlLP, { headers: headers, params: paramsx }).toPromise();
  }


  getAdvertiserReportCampaignDateList(pCampaignID, DateTo, DateFrom,
    CampaignName, CheckAllCampaign,
    VerticalID, VerticalName,
    AdCompanyID, AdCompanyName
  ) {
    var urlLP = hostGeneral + "/api/AdvertiserReport/GetAdvertiserReportCampaignDateList";
    let paramsx = new HttpParams();
    paramsx = paramsx.append("AdCampaignID", pCampaignID);
    paramsx = paramsx.append("DateTo", this.ReturnYMD(DateTo));
    paramsx = paramsx.append("DateFrom", this.ReturnYMD(DateFrom));
    paramsx = paramsx.append("CampaignName", CampaignName);
    paramsx = paramsx.append("CheckAllCampaign", CheckAllCampaign);
    paramsx = paramsx.append("VerticalID", VerticalID);
    paramsx = paramsx.append("VerticalName", VerticalName);
    return this.http.get(urlLP, { headers: headers, params: paramsx }).toPromise();

    //return this.http.get(urlLP).toPromise();
  }

  getAdvertiserReportAdvertiserDateList(pCampaignID, DateTo, DateFrom,
    CampaignName, CheckAllCampaign,
    VerticalID, VerticalName
  ) {
    var urlLP = hostGeneral + "/api/AdvertiserReport/GetAdvertiserReportListByAdvertiserDate";
    let paramsx = new HttpParams();
    paramsx = paramsx.append("AdCampaignID", pCampaignID);
    paramsx = paramsx.append("DateTo", this.ReturnYMD(DateTo));
    paramsx = paramsx.append("DateFrom", this.ReturnYMD(DateFrom));
    paramsx = paramsx.append("CampaignName", CampaignName);
    paramsx = paramsx.append("CheckAllCampaign", CheckAllCampaign);
    paramsx = paramsx.append("VerticalID", VerticalID);
    paramsx = paramsx.append("VerticalName", VerticalName);
    return this.http.get(urlLP, { headers: headers, params: paramsx }).toPromise();

    //return this.http.get(urlLP).toPromise();
  }

  getCampaignList() {
    var urlLP = hostGeneral + "/api/AdCampaign/GetAdCampaignList";
    return this.http.get(urlLP, this.httpOptions2).toPromise();
  }

  getAdCampaignByCompanyANDVerticalList(VerticalID, AdCampaignID) {
    //var urlLP = hostGeneral+"/api/PublisherReport/GetPublisherReportByVertical";
    var urlLP = hostGeneral + "/api/AdCampaign/GetAdCampaignListByCompanyVertical";
    let paramsx = new HttpParams();
    paramsx = paramsx.append("VerticalID", VerticalID);
    paramsx = paramsx.append("AdCompanyID", AdCampaignID);
    return this.http.get(urlLP, { headers: headers, params: paramsx }).toPromise();
  }




  getPublisherDataByAdFeed(AdFeedID) {
    //var urlLP = hostGeneral+"/api/PublisherReport/GetPublisherReportByVertical";
    var urlLP = hostGeneral + "/api/Publishers/GetPublisherByFeed";
    let paramsx = new HttpParams();
    paramsx = paramsx.append("AdFeedID", AdFeedID);
    return this.http.get(urlLP, { headers: headers, params: paramsx }).toPromise();
  }

  getAdCampaignByCompanyANDVerticalByFeedList(VerticalID, AdCampaignID, AdFeedID) {
    //var urlLP = hostGeneral+"/api/PublisherReport/GetPublisherReportByVertical";
    var urlLP = hostGeneral + "/api/AdCampaign/GetAdCampaignListByCompanyVerticalByFeed";
    let paramsx = new HttpParams();
    paramsx = paramsx.append("VerticalID", VerticalID);
    paramsx = paramsx.append("AdCompanyID", AdCampaignID);
    paramsx = paramsx.append("AdFeedID", AdFeedID);
    return this.http.get(urlLP, { headers: headers, params: paramsx }).toPromise();
  }

  getCampaignCap(adCampaignID) {
    //var urlLP = hostGeneral+"/api/PublisherReport/GetPublisherReportByVertical";
    var urlLP = hostGeneral + "/api/AdCampaign/GetCampaignCap";
    let paramsx = new HttpParams();
    paramsx = paramsx.append("AdCampaignID", adCampaignID);
    return this.http.get(urlLP, { headers: headers, params: paramsx }).toPromise();
  }


  //getAdCampaignByVerticalByUser
  getAdCampaignByCompanyVerticalByUser(VerticalID, AdCompanyID, AdUserID) {

    var urlLP = hostGeneral + "/api/AdCampaign/GetAdCampaignByCompanyVerticalByUser";
    let paramsx = new HttpParams();
    paramsx = paramsx.append("VerticalID", VerticalID);
    paramsx = paramsx.append("AdCompanyID", AdCompanyID);
    paramsx = paramsx.append("AdUserID", AdUserID);
    return this.http.get(urlLP, { headers: headers, params: paramsx }).toPromise();
  }

  getAdCampaignByVerticalByUser(AdUserID, VerticalID) {

    var urlLP = hostGeneral + "/api/AdCampaign/GetAdCampaignByVerticalByUser";
    let paramsx = new HttpParams();
    paramsx = paramsx.append("VerticalID", VerticalID);
    paramsx = paramsx.append("AdUserID", AdUserID);
    return this.http.get(urlLP, { headers: headers, params: paramsx }).toPromise();
  }



  getAdCampaignByCompanyVerticalByPublisherByFeed(VerticalID, AdCampaignID, PublisherID, FeedID) {

    var urlLP = hostGeneral + "/api/AdCampaign/GetAdCampaignByVerticalByPublisherByFeedID";
    let paramsx = new HttpParams();
    paramsx = paramsx.append("VerticalID", VerticalID);
    paramsx = paramsx.append("AdCompanyID", AdCampaignID);
    paramsx = paramsx.append("PublisherID", PublisherID);
    paramsx = paramsx.append("FeedID", FeedID);
    return this.http.get(urlLP, { headers: headers, params: paramsx }).toPromise();
  }

  getAdCampaignByCompanyVerticalByUserByFeed(VerticalID, AdCompanyID, AdUserID, FeedID) {

    var urlLP = hostGeneral + "/api/AdCampaign/GetAdCampaignByVerticalByUserByFeedID";
    let paramsx = new HttpParams();
    paramsx = paramsx.append("VerticalID", VerticalID);
    paramsx = paramsx.append("AdCompanyID", AdCompanyID);
    paramsx = paramsx.append("AdUserID", AdUserID);
    paramsx = paramsx.append("FeedID", FeedID);
    return this.http.get(urlLP, { headers: headers, params: paramsx }).toPromise();
  }


  getPublisherReportByPublisherVerticalList(PublisherID, VerticalID, DateFrom, DateTo) {
    var urlLP = hostGeneral + "/api/PublisherReport/GetPublisherReportByPublisherVertical";
    let paramsx = new HttpParams();
    paramsx = paramsx.append("VerticalID", VerticalID);
    paramsx = paramsx.append("PublisherID", PublisherID);
    paramsx = paramsx.append("DateFrom", this.ReturnYMD(DateFrom));
    paramsx = paramsx.append("DateTo", this.ReturnYMD(DateTo));

    return this.http.get(urlLP, { headers: headers, params: paramsx }).toPromise();
  }

  getPublisherByVerticalList(VerticalID) {
    var urlLP = hostGeneral + "/api/Publishers/GetPublisherByVerticalList";
    let paramsx = new HttpParams();
    paramsx = paramsx.append("VerticalID", VerticalID);
    return this.http.get(urlLP, { headers: headers, params: paramsx }).toPromise();
  }

  getPublisherByVerticalByUserList(VerticalID, UserID) {
    var urlLP = hostGeneral + "/api/Publishers/GetPublisherByVerticalByUserList";
    let paramsx = new HttpParams();
    paramsx = paramsx.append("VerticalID", VerticalID);
    paramsx = paramsx.append("UserID", UserID);
    return this.http.get(urlLP, { headers: headers, params: paramsx }).toPromise();
  }



  getCampaignByCompanyList(pCompanyID) {
    var urlLP = hostGeneral + "/api/AdCampaign/GetAdCampaignListByCompany";
    let paramsx = new HttpParams().set("AdCompanyID", pCompanyID); //Create new HttpParams
    return this.http.get(urlLP, { headers: headers, params: paramsx }).toPromise();
  }

  getCampaignListByCompanyList(AdCompanyIDList: number[]) {
    var urlLP = hostGeneral + "/api/AdCampaign/GetAdCampaingListByCompanyList";
    let paramsx = new HttpParams().set("AdCompanyIDList", AdCompanyIDList.join(',')); //Create new HttpParams
    return this.http.get(urlLP, { headers: headers, params: paramsx }).toPromise();
  }

  getCampaignByVerticalList(pVerticalID) {
    var urlLP = hostGeneral + "/api/AdCampaign/GetAdCampaignListByVertical";
    let paramsx = new HttpParams().set("VerticalID", pVerticalID);
    return this.http.get(urlLP, { headers: headers, params: paramsx }).toPromise();
  }

  // **** 2021-10-05 JFRH: Método getCampaignByCampaignID() para traer una Campaign
  getCampaignByCampaignID(pCampaignID) {
    var urlLP = hostGeneral + "/api/AdCampaign/GetAdCampaignByCampaignID";
    let paramsx = new HttpParams().set("AdCampaignID", pCampaignID); //Create new HttpParams
    return this.http.get(urlLP, { headers: headers, params: paramsx }).toPromise();
  }

  getConsumerTypeList() {
    var urlLP = hostGeneral + "/api/ConsumerType/GetConsumerTypeList";
    return this.http.get(urlLP, this.httpOptions2).toPromise();
  }

  getCampaignBidList() {
    var urlLP = hostGeneral + "/api/CampaignBid/GetCampaignBidList";
    return this.http.get(urlLP, this.httpOptions2).toPromise();
  }

  getAdNetworkTypeList() {
    var urlLP = hostGeneral + "/api/AdNetworkType/GetAdNetworkTypeList";
    return this.http.get(urlLP, this.httpOptions2).toPromise();
  }

  getCompanyList() {
    var urlLP = hostGeneral + "/api/Company/GetCompanyList";
    return this.http.get(urlLP, this.httpOptions2).toPromise();
    //return this.http.get(`${hostGeneral}/api/Verticals/GetVerticalList`, this.httpOptions2).toPromise();
  }

  getCompanyListByAsociateUser(AdUserID) {
    var urlLP = hostGeneral + "/api/Company/GetCompanyListByUserAsocited";
    let paramsx = new HttpParams();
    paramsx = paramsx.append("AdUserID", AdUserID);
    return this.http.get(urlLP, { headers: headers, params: paramsx }).toPromise();
  }



  getCompanyListByAsociateUserByVertical(AdUserID, VerticalID) {
    var urlLP = hostGeneral + "/api/Company/GetCompanyListByUserAsocitedByVertical";
    let paramsx = new HttpParams();
    paramsx = paramsx.append("AdUserID", AdUserID);
    paramsx = paramsx.append("VerticalID", VerticalID);
    return this.http.get(urlLP, { headers: headers, params: paramsx }).toPromise();
  }


  getCompanyListByPublisherByFeedAsociated(PublisherID, AdFeedID) {
    var urlLP = hostGeneral + "/api/Company/GetCompanyListByPublisherByFeedAsociated";
    let paramsx = new HttpParams();
    paramsx = paramsx.append("PublisherID", PublisherID);
    paramsx = paramsx.append("FeedID", AdFeedID);
    return this.http.get(urlLP, { headers: headers, params: paramsx }).toPromise();
  }

  getCompanyListByUserByFeedAsociated(UserID, AdFeedID) {
    var urlLP = hostGeneral + "/api/Company/GetCompanyListByUserByFeedAsociated";
    let paramsx = new HttpParams();
    paramsx = paramsx.append("UserID", UserID);
    paramsx = paramsx.append("FeedID", AdFeedID);
    return this.http.get(urlLP, { headers: headers, params: paramsx }).toPromise();
  }

  getAllCompanyListByUserByFeedAsociated(UserID, AdFeedID) {
    var urlLP = hostGeneral + "/api/Company/GetAllCompanyListByUserByFeedAsociated";
    let paramsx = new HttpParams();
    paramsx = paramsx.append("UserID", UserID);
    paramsx = paramsx.append("FeedID", AdFeedID);
    return this.http.get(urlLP, { headers: headers, params: paramsx }).toPromise();
  }

  getCompanyListByFeed(AdFeedID) {
    var urlLP = hostGeneral + "/api/Company/GetCompanyListByFeed";
    let paramsx = new HttpParams().set("AdFeedID", AdFeedID);
    return this.http.get(urlLP, { headers: headers, params: paramsx }).toPromise();

  }

  getCompanyListByFeedByUser(AdFeedID, UserID) {
    var urlLP = hostGeneral + "/api/Company/GetCompanyListByFeedByUser";
    let paramsx = new HttpParams();
    paramsx = paramsx.append("UserID", UserID);
    paramsx = paramsx.append("AdFeedID", AdFeedID);
    return this.http.get(urlLP, { headers: headers, params: paramsx }).toPromise();

  }


  getCompanyListByAdNetworkAPIID(AdNetworkAPIID) {
    var urlLP = hostGeneral + "/api/Company/GetCompanyListByAdNetworkAPIID";
    let paramsx = new HttpParams().set("AdNetworkAPIID", AdNetworkAPIID);
    return this.http.get(urlLP, { headers: headers, params: paramsx }).toPromise();
  }

  getAllCompanyListByAdNetworkAPIID(AdNetworkAPIID) {
    var urlLP = hostGeneral + "/api/Company/GetAllCompanyListByAdNetworkAPIID";
    let paramsx = new HttpParams().set("AdNetworkAPIID", AdNetworkAPIID);
    return this.http.get(urlLP, { headers: headers, params: paramsx }).toPromise();
  }

  GetCompanyListByAdNetworkAPIByUser(AdNetworkAPIID, UserID) {
    var urlLP = hostGeneral + "/api/Company/GetCompanyListByAdNetworkAPIByUser";
    let paramsx = new HttpParams();
    paramsx = paramsx.append("UserID", UserID);
    paramsx = paramsx.append("AdNetworkAPiID", AdNetworkAPIID);
    return this.http.get(urlLP, { headers: headers, params: paramsx }).toPromise();

  }

  getCompanyListByVertical(VerticalID) {
    var urlLP = hostGeneral + "/api/Company/GetCompanyListByVertical";
    let paramsx = new HttpParams().set("VerticalID", VerticalID);
    return this.http.get(urlLP, { headers: headers, params: paramsx }).toPromise();

  }

  getCompanyListByVerticalByFeed(VerticalID, AdFeedID) {
    var urlLP = hostGeneral + "/api/Company/GetCompanyListByVerticalByFeed";
    let paramsx = new HttpParams();
    paramsx = paramsx.append("VerticalID", VerticalID);
    paramsx = paramsx.append("AdFeedID", AdFeedID);
    return this.http.get(urlLP, { headers: headers, params: paramsx }).toPromise();
  }


  getCompanyByVerticalAndFeedID(VerticalID, AdFeedID) {
    var urlLP = hostGeneral + "/api/Company/GetCompanyByVerticalAndFeedID";
    let paramsx = new HttpParams();
    paramsx = paramsx.append("verticalID", VerticalID);
    paramsx = paramsx.append("feedID", AdFeedID);
    return this.http.get(urlLP, { headers: headers, params: paramsx }).toPromise();
  }



  getDashBoardPubRequestTotalPeriodBySP(VerticalID, PublisherID, ShowAllVertical, StartDate, EndDate, RangeID) {
    let paramsx = new HttpParams();
    var urlAdNetwork = hostGeneral + "/api/Dashboard/GetDashBoardPubRequestTotalPeriodBySP";
    paramsx = paramsx.append("VerticalID", VerticalID);
    paramsx = paramsx.append("PublisherID", PublisherID);
    paramsx = paramsx.append("ShowAllVertical", ShowAllVertical);
    paramsx = paramsx.append("StartDate", this.ReturnYMD(StartDate));
    paramsx = paramsx.append("EndDate", this.ReturnYMD(EndDate));
    paramsx = paramsx.append("RangeID", RangeID);
    return this.http.get(urlAdNetwork, { headers: headers, params: paramsx }).toPromise();

  }

  getDashBoardRevenueTotalBySP(VerticalID, AdNetworkAPIID, ShowAllVertical, StartDate, EndDate, AdUserID, RoleID, RangeID) {
    let paramsx = new HttpParams();
    var urlAdNetwork = hostGeneral + "/api/Dashboard/GetDashBoardRevenueTotalBySP";
    paramsx = paramsx.append("VerticalID", VerticalID);
    paramsx = paramsx.append("AdNetworkAPIID", AdNetworkAPIID);
    paramsx = paramsx.append("ShowAllVertical", ShowAllVertical);
    paramsx = paramsx.append("StartDate", this.ReturnYMD(StartDate));
    paramsx = paramsx.append("EndDate", this.ReturnYMD(EndDate));
    paramsx = paramsx.append("AdUserID", AdUserID);   // **** 2021-06-18: JFRH: pasar también AdUserID para cuando RoleID = 3
    paramsx = paramsx.append("RoleID", RoleID);
    paramsx = paramsx.append("RangeID", RangeID);     // ** 2021-05-17: JFRH: pasar también RangeID para determinar cómo agrupar por fecha

    return this.http.get(urlAdNetwork, { headers: headers, params: paramsx }).toPromise();
  }

  // **** 2021-05-21: JFRH: Llamada a API para obtener total Revenue, Spend y Profit para KPI's
  getDashBoardRevenueTotalKPIBySP(VerticalID, ShowAllVertical, StartDate, EndDate, AdUserID, RoleID, RangeID) {
    let paramsx = new HttpParams();
    var urlAdNetwork = hostGeneral + "/api/Dashboard/GetDashBoardRevenueTotalKPIBySP";
    paramsx = paramsx.append("VerticalID", VerticalID);
    paramsx = paramsx.append("ShowAllVertical", ShowAllVertical);
    paramsx = paramsx.append("StartDate", this.ReturnYMD(StartDate));
    paramsx = paramsx.append("EndDate", this.ReturnYMD(EndDate));
    paramsx = paramsx.append("AdUserID", AdUserID);
    paramsx = paramsx.append("RoleID", RoleID);
    paramsx = paramsx.append("RangeID", RangeID);

    return this.http.get(urlAdNetwork, { headers: headers, params: paramsx }).toPromise();
  }


  getDynamicDashboardBySP(VerticalID, AdNetworkAPIID, AdvertiserID, PublisherID, StartDate, EndDate,
    ShowAllVertical, ShowAllAdNetworkAPIID, ShowAllAdvertiser, AdUserID, RoleID) {
    // ** 2021-04-22: JFRH: Se agregaron los parámetros VerticalID y ShowAllVertical a la llamada
    let paramsx = new HttpParams();
    var urlAdNetwork = hostGeneral + "/api/Dashboard/GetDashBoardBySP";
    paramsx = paramsx.append("VerticalID", VerticalID);
    paramsx = paramsx.append("AdNetworkAPIID", AdNetworkAPIID);
    paramsx = paramsx.append("AdvertiserID", AdvertiserID);
    paramsx = paramsx.append("PublisherID", PublisherID);
    paramsx = paramsx.append("StartDate", this.ReturnYMD(StartDate));
    paramsx = paramsx.append("EndDate", this.ReturnYMD(EndDate));
    paramsx = paramsx.append("ShowAllVertical", ShowAllVertical);
    paramsx = paramsx.append("ShowAllAdNetworkAPIID", ShowAllAdNetworkAPIID);
    paramsx = paramsx.append("ShowAllAdvertiser", ShowAllAdvertiser);
    paramsx = paramsx.append("AdUserID", AdUserID);
    paramsx = paramsx.append("RoleID", RoleID);
    paramsx = paramsx.append("Version", "2");
    return this.http.get(urlAdNetwork, { headers: headers, params: paramsx }).toPromise();

  }


  getAdCampaignConstraintValuesByCampaign(AdCampaignID) {
    var urlLP = hostGeneral + "/api/AdCampaignConstraintValue/GetAdCampaignConstraintValuesByCampaignList";
    let paramsx = new HttpParams();
    paramsx = paramsx.append("AdCampaignID", AdCampaignID);
    return this.http.get(urlLP, { headers: headers, params: paramsx }).toPromise();
  }

  getAdConstraintTypeList() {
    var urlLP = hostGeneral + "/api/AdConstraintType/GetAdConstraintTypeList";
    return this.http.get(urlLP, this.httpOptions2).toPromise();
  }

  getAdConstraintTypeByVerticalList(VerticalID) {
    var urlLP = hostGeneral + "/api/AdConstraintType/GetAdConstraintTypeByVerticalList";
    let paramsx = new HttpParams();
    paramsx = paramsx.append("VerticalID", VerticalID);
    return this.http.get(urlLP, { headers: headers, params: paramsx }).toPromise();
  }

  GetAdConstraintTypeByVerticalByLandingPage(VerticalID, LandingPageID) {
    var urlLP = hostGeneral + "/api/AdConstraintType/GetAdConstraintTypeByVerticalByLandingPage";
    let paramsx = new HttpParams();
    paramsx = paramsx.append("VerticalID", VerticalID);
    paramsx = paramsx.append("LandingPageID", LandingPageID);
    return this.http.get(urlLP, { headers: headers, params: paramsx }).toPromise();
  }



  getAdConstraintAllowedValuesListByVertical(VerticalID) {
    var urlLP = hostGeneral + "/api/AdConstraintAllowedValues/GetAdConstraintAllowedValuesByVertical";
    let paramsx = new HttpParams();
    paramsx = paramsx.append("VerticalID", VerticalID);
    return this.http.get(urlLP, { headers: headers, params: paramsx }).toPromise();
  }

  getConsumerConstraintAllowedValuesListByVerticalAdFeed(VerticalID, AdFeedID) {
    var urlLP = hostGeneral + "/api/AdConstraintAllowedValues/GetConsumerConstraintAllowedValuesByVerticalAdFeed";
    let paramsx = new HttpParams();
    paramsx = paramsx.append("VerticalID", VerticalID);
    paramsx = paramsx.append("AdFeedID", AdFeedID);
    return this.http.get(urlLP, { headers: headers, params: paramsx }).toPromise();
  }

  getAdConstraintAllowedValuesList() {
    var urlLP = hostGeneral + "/api/AdConstraintAllowedValues/AdConstraintAllowedValuesList";
    return this.http.get(urlLP, this.httpOptions2).toPromise();
  }

  getAdConstraintAllowedValuesByVerticalConstraintType(VerticalID, ConstraintTypeID) {
    var urlLP = hostGeneral + "/api/AdConstraintAllowedValues/GetAdConstraintAllowedValuesByVertical";
    let paramsx = new HttpParams();
    paramsx = paramsx.append("VerticalID", VerticalID);
    paramsx = paramsx.append("ConstraintTypeID", ConstraintTypeID);

    return this.http.get(urlLP, { headers: headers, params: paramsx }).toPromise();

    //return this.http.get(urlLP).toPromise();
  }


  getAdConstraintAllowedValuesListByType(AdConstraintTypeID) {
    var urlLP = hostGeneral + "/api/AdConstraintAllowedValues/AdConstraintAllowedValuesByConstraintTypeList";
    let paramsx = new HttpParams();
    paramsx = paramsx.append("AdConstraintTypeID", AdConstraintTypeID);
    return this.http.get(urlLP, { headers: headers, params: paramsx }).toPromise();
  }

  getLandingPageRenderList() {
    var urlLP = hostGeneral + "/api/LandingPageRendeMode/GetLandingPageRendeModeList";
    return this.http.get(urlLP, this.httpOptions2).toPromise();
  }

  getAdFeedList() {

    var urlLP = hostGeneral + "/api/AdFeed/GetAdFeedList";
    let paramsx = new HttpParams();
    // paramsx = paramsx.append("CompanyID", CompanyID);
    return this.http.get(urlLP, { headers: headers, params: paramsx }).toPromise();
  }



  getAdFeedListByUser(AdUserID) {
    //get List Adfeed by a userID
    var urlStr = hostGeneral + "/api/AdFeed/GetAdFeedByUserList";
    let paramsx = new HttpParams();
    paramsx = paramsx.append("ADUserID", AdUserID);
    return this.http.get(urlStr, { headers: headers, params: paramsx }).toPromise();
  }

  getAdFeedListByPublisher(PublisherID) {
    //get List Adfeed by a PublisherID
    var urlStr = hostGeneral + "/api/AdFeed/GetAdFeedByPublisherList";
    let paramsx = new HttpParams();
    paramsx = paramsx.append("PublisherID", PublisherID);
    return this.http.get(urlStr, { headers: headers, params: paramsx }).toPromise();
  }

  GetAdFeedOfMenuByPublisher(PublisherID) {
    //get List Adfeed by a PublisherID
    var urlStr = hostGeneral + "/api/AdFeed/GetAdFeedOfMenuByPublisher";
    let paramsx = new HttpParams();
    paramsx = paramsx.append("PublisherID", PublisherID);
    return this.http.get(urlStr, { headers: headers, params: paramsx }).toPromise();
  }

  ValidateUserAdNetwork(UserID, AdFeedID) {
    //get List Adfeed by a PublisherID
    var urlStr = hostGeneral + "/api/AdFeed/ValidateUserAdNetwork";
    let paramsx = new HttpParams();
    paramsx = paramsx.append("UserID", UserID);
    paramsx = paramsx.append("AdFeedID", AdFeedID);
    return this.http.get(urlStr, { headers: headers, params: paramsx }).toPromise();
  }

  cloneExchange(post: any): Observable<any> {
    return this.http.post<any>(`${hostGeneral}/api/AdFeed/CloneExchange`, post, { headers });
  }

  getVerticalByAdFeed(AdFeedID) {
    //get a AdFeed by User
    var urlStr = hostGeneral + "/api/CampaignUser/GetVerticalByAdFeed";
    let paramsx = new HttpParams();
    paramsx = paramsx.append("AdFeedID", AdFeedID);
    return this.http.get(urlStr, { headers: headers, params: paramsx }).toPromise();
  }

  getAdFeedByUser(AdUserID) {
    //get a AdFeed by User
    var urlStr = hostGeneral + "/api/CampaignUser/GetAdFeedIDByUser";
    let paramsx = new HttpParams();
    paramsx = paramsx.append("AdUserID", AdUserID);
    return this.http.get(urlStr, { headers: headers, params: paramsx }).toPromise();
  }

  getCompanyByID(CompanyID) {
    var urlLP = hostGeneral + "/api/Company/GetCompanyByID";
    let paramsx = new HttpParams();
    paramsx = paramsx.append("CompanyID", CompanyID);
    return this.http.get(urlLP, { headers: headers, params: paramsx }).toPromise();
    //return this.http.get(urlLP, { params: paramsx }).toPromise();
  }

  getPublisherByID(PublisherID) {
    var urlLP = hostGeneral + "/api/Publishers/GetPublisherByID";
    let paramsx = new HttpParams();
    paramsx = paramsx.append("PublisherID", PublisherID);
    return this.http.get(urlLP, { headers: headers, params: paramsx }).toPromise();
  }

  // getPublisherByFeed(AdFeedID) {
  //   var urlLP = hostGeneral + "/api/Publishers/GetPublisherByID";
  //   let paramsx = new HttpParams();
  //   paramsx = paramsx.append("AdFeedID", AdFeedID);
  //   return this.http.get(urlLP, { headers: headers, params: paramsx }).toPromise();
  // }

  getAdNetworkID(AdNetworkID) {
    var urlLP = hostGeneral + "/api/AdNetworks/GetAdNetworkID";
    let paramsx = new HttpParams().set("AdNetworkID", AdNetworkID); //Create new HttpParams
    return this.http.get(urlLP, { headers: headers, params: paramsx }).toPromise();
    //return this.http.get(urlLP).toPromise();
  }

  /**
   * Description: Function to update Bid Modifier Percentage filtered by AdConstraintAllowedValueID 
   * and AdCampaignID in data model. 
   * @param bidModifierValues: [JSONstring] object with all Bid Modifier modified values. 
   * @returns 
   */
  updateBidModifierPercentage(bidModifierValues) {
    const url: string = `${hostGeneral}/api/AdCampaignConstraintValue/updateBidModifierPercentage`;
    const body = { bidModifierValues }
    const parameters = new HttpParams().set("bidModifierValues", bidModifierValues);
    return this.http.post(url, body, {
      headers: headers,
      params: parameters
    }).toPromise();
  }


  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };


  }

  // **** 2021-06-02: JFRH: Llamada a API para obtener total Requests, Live Impressions, Clicks, eCPC, Leads y eCPS para line chart de KPI's

  getDashBoardRequestsTotalKPIBySP(VerticalID, ShowAllVertical, StartDate, EndDate, AdUserID, RoleID, RangeID) {
    let paramsx = new HttpParams();
    var urlAdNetwork = hostGeneral + "/api/Dashboard/GetDashBoardRequestsTotalKPIBySP";
    paramsx = paramsx.append("VerticalID", VerticalID);
    paramsx = paramsx.append("ShowAllVertical", ShowAllVertical);
    paramsx = paramsx.append("StartDate", this.ReturnYMD(StartDate));
    paramsx = paramsx.append("EndDate", this.ReturnYMD(EndDate));
    paramsx = paramsx.append("AdUserID", AdUserID);
    paramsx = paramsx.append("RoleID", RoleID);
    paramsx = paramsx.append("RangeID", RangeID);

    return this.http.get(urlAdNetwork, { headers: headers, params: paramsx }).toPromise();
  }


  // ---- Calls Dashboard API methods ----

  getDynamicDashboardCallBySP(VerticalID, AdNetworkAPIID, AdvertiserID, PublisherID, StartDate, EndDate,
    ShowAllVertical, ShowAllAdNetworkAPIID, ShowAllAdvertiser, AdUserID, RoleID) {
    let paramsx = new HttpParams();
    var urlAdNetwork = hostGeneral + "/api/Dashboard/GetDashBoardCallBySP";
    paramsx = paramsx.append("VerticalID", VerticalID);
    paramsx = paramsx.append("AdNetworkAPIID", AdNetworkAPIID);
    paramsx = paramsx.append("AdvertiserID", AdvertiserID);
    paramsx = paramsx.append("PublisherID", PublisherID);
    paramsx = paramsx.append("StartDate", this.ReturnYMD(StartDate));
    paramsx = paramsx.append("EndDate", this.ReturnYMD(EndDate));
    paramsx = paramsx.append("ShowAllVertical", ShowAllVertical);
    paramsx = paramsx.append("ShowAllAdNetworkAPIID", ShowAllAdNetworkAPIID);
    paramsx = paramsx.append("ShowAllAdvertiser", ShowAllAdvertiser);
    paramsx = paramsx.append("AdUserID", AdUserID);
    paramsx = paramsx.append("RoleID", RoleID);
    paramsx = paramsx.append("Version", "2");
    return this.http.get(urlAdNetwork, { headers: headers, params: paramsx }).toPromise();
  }

  getDashBoardRevenueCallTotalBySP(VerticalID, AdNetworkAPIID, ShowAllVertical, StartDate, EndDate, AdUserID, RoleID, RangeID) {
    let paramsx = new HttpParams();
    var urlAdNetwork = hostGeneral + "/api/Dashboard/GetDashBoardRevenueCallTotalBySP";
    paramsx = paramsx.append("VerticalID", VerticalID);
    paramsx = paramsx.append("AdNetworkAPIID", AdNetworkAPIID);
    paramsx = paramsx.append("ShowAllVertical", ShowAllVertical);
    paramsx = paramsx.append("StartDate", this.ReturnYMD(StartDate));
    paramsx = paramsx.append("EndDate", this.ReturnYMD(EndDate));
    paramsx = paramsx.append("AdUserID", AdUserID);
    paramsx = paramsx.append("RoleID", RoleID);
    paramsx = paramsx.append("RangeID", RangeID);
    return this.http.get(urlAdNetwork, { headers: headers, params: paramsx }).toPromise();
  }

  getDashBoardRevenueCallTotalKPIBySP(VerticalID, ShowAllVertical, StartDate, EndDate, AdUserID, RoleID, RangeID) {
    let paramsx = new HttpParams();
    var urlAdNetwork = hostGeneral + "/api/Dashboard/GetDashBoardRevenueCallTotalKPIBySP";
    paramsx = paramsx.append("VerticalID", VerticalID);
    paramsx = paramsx.append("ShowAllVertical", ShowAllVertical);
    paramsx = paramsx.append("StartDate", this.ReturnYMD(StartDate));
    paramsx = paramsx.append("EndDate", this.ReturnYMD(EndDate));
    paramsx = paramsx.append("AdUserID", AdUserID);
    paramsx = paramsx.append("RoleID", RoleID);
    paramsx = paramsx.append("RangeID", RangeID);
    return this.http.get(urlAdNetwork, { headers: headers, params: paramsx }).toPromise();
  }

  getDashBoardPubRequestCallTotalPeriodBySP(VerticalID, PublisherID, ShowAllVertical, StartDate, EndDate, RangeID) {
    let paramsx = new HttpParams();
    var urlAdNetwork = hostGeneral + "/api/Dashboard/GetDashBoardPubRequestCallTotalPeriodBySP";
    paramsx = paramsx.append("VerticalID", VerticalID);
    paramsx = paramsx.append("PublisherID", PublisherID);
    paramsx = paramsx.append("ShowAllVertical", ShowAllVertical);
    paramsx = paramsx.append("StartDate", this.ReturnYMD(StartDate));
    paramsx = paramsx.append("EndDate", this.ReturnYMD(EndDate));
    paramsx = paramsx.append("RangeID", RangeID);
    return this.http.get(urlAdNetwork, { headers: headers, params: paramsx }).toPromise();
  }

  getDashBoardRequestsCallTotalKPIBySP(VerticalID, ShowAllVertical, StartDate, EndDate, AdUserID, RoleID, RangeID) {
    let paramsx = new HttpParams();
    var urlAdNetwork = hostGeneral + "/api/Dashboard/GetDashBoardRequestsCallTotalKPIBySP";
    paramsx = paramsx.append("VerticalID", VerticalID);
    paramsx = paramsx.append("ShowAllVertical", ShowAllVertical);
    paramsx = paramsx.append("StartDate", this.ReturnYMD(StartDate));
    paramsx = paramsx.append("EndDate", this.ReturnYMD(EndDate));
    paramsx = paramsx.append("AdUserID", AdUserID);
    paramsx = paramsx.append("RoleID", RoleID);
    paramsx = paramsx.append("RangeID", RangeID);
    return this.http.get(urlAdNetwork, { headers: headers, params: paramsx }).toPromise();
  }

  getDataAdminReportCallBySP(VerticalID, AdNetworkAPIID, AdvertiserID, CampaignID, PublisherID, StartDate, EndDate,
    ShowAllVertical, ShowAllAdNetworkAPIID, ShowAllAdvertiser, ShowAllCampaign, ShowAllPublisher, UserID, RoleID, BrandName, ShowAllBrandName, landingPageID, showAllLandingPages,
    groupByMonth, SourceID, ShowAllSourceIDs) {
    let paramsx = new HttpParams();
    // var urlAdNetwork = hostGeneral + "/api/AdminReport/GetAdminReportCallBySP";
    var urlAdNetwork = `${hostGeneral}/api/AdminCallReport/GetAdminCallReport`;
    paramsx = paramsx.append("VerticalID", VerticalID);
    paramsx = paramsx.append("AdNetworkAPIID", AdNetworkAPIID);
    paramsx = paramsx.append("AdvertiserID", AdvertiserID);
    paramsx = paramsx.append("CampaignID", CampaignID);
    paramsx = paramsx.append("PublisherID", PublisherID);
    paramsx = paramsx.append("StartDate", this.ReturnYMD(StartDate));
    paramsx = paramsx.append("EndDate", this.ReturnYMD(EndDate));
    paramsx = paramsx.append("ShowAllVertical", ShowAllVertical);// == 1 ? "true" : "false");
    paramsx = paramsx.append("ShowAllAdNetworkAPIID", ShowAllAdNetworkAPIID);// == 1 ? "true" : "false");
    paramsx = paramsx.append("ShowAllAdvertiser", ShowAllAdvertiser);// == 1 ? "true" : "false");
    paramsx = paramsx.append("ShowAllCampaign", ShowAllCampaign);// == 1 ? "true" : "false");
    paramsx = paramsx.append("ShowAllPublisher", ShowAllPublisher);// == 1 ? "true" : "false");
    paramsx = paramsx.append("AdUserID", UserID);
    paramsx = paramsx.append("RoleID", RoleID);
    paramsx = paramsx.append("BillToName", "");
    // paramsx = paramsx.append("BrandName", BrandName);
    // paramsx = paramsx.append("ShowAllBrandName", ShowAllBrandName);
    // paramsx = paramsx.append("LandingPageID", landingPageID);
    // paramsx = paramsx.append("ShowAllLandingPages", showAllLandingPages);
    // paramsx = paramsx.append("GroupByMonth", groupByMonth);
    // paramsx = paramsx.append("SourceID", SourceID);
    // paramsx = paramsx.append("ShowAllSourceIDs", ShowAllSourceIDs);
    // paramsx = paramsx.append("Version", "2");
    return this.http.get(urlAdNetwork, { headers: headers, params: paramsx }).toPromise();
  }

  getDataAdminReportCallTotalsBySP(VerticalID, PublisherID, ShowAllVertical, StartDate, EndDate) {
    let paramsx = new HttpParams();
    var urlAdNetwork = hostGeneral + "/api/AdminCallReport/GetAdminReportCallBySPTotal";
    paramsx = paramsx.append("VerticalID", VerticalID);
    paramsx = paramsx.append("PublisherID", PublisherID);
    paramsx = paramsx.append("ShowAllVertical", ShowAllVertical);
    paramsx = paramsx.append("StartDate", this.ReturnYMD(StartDate));
    paramsx = paramsx.append("EndDate", this.ReturnYMD(EndDate));
    return this.http.get(urlAdNetwork, { headers: headers, params: paramsx }).toPromise();
  }

  getDataAdminReportCallBySPAdvertiser(VerticalID, AdNetworkAPIID, AdvertiserID, CampaignID, PublisherID, StartDate, EndDate,
    ShowAllVertical, ShowAllAdNetworkAPIID, ShowAllAdvertiser, ShowAllCampaign, ShowAllPublisher, AdUserID, RoleID) {
    let paramsx = new HttpParams();
    var urlAdNetwork = hostGeneral + "/api/AdminReport/GetAdminReportCallBySPAdvertiserV2";
    paramsx = paramsx.append("VerticalID", VerticalID);
    paramsx = paramsx.append("AdNetworkAPIID", AdNetworkAPIID);
    paramsx = paramsx.append("AdvertiserID", AdvertiserID);
    paramsx = paramsx.append("CampaignID", CampaignID);
    paramsx = paramsx.append("PublisherID", PublisherID);
    paramsx = paramsx.append("StartDate", this.ReturnYMD(StartDate));
    paramsx = paramsx.append("EndDate", this.ReturnYMD(EndDate));
    paramsx = paramsx.append("ShowAllVertical", ShowAllVertical);
    paramsx = paramsx.append("ShowAllAdNetworkAPIID", ShowAllAdNetworkAPIID);
    paramsx = paramsx.append("ShowAllAdvertiser", ShowAllAdvertiser);
    paramsx = paramsx.append("ShowAllCampaign", ShowAllCampaign);
    paramsx = paramsx.append("ShowAllPublisher", ShowAllPublisher);
    paramsx = paramsx.append("AdUserID", AdUserID);
    paramsx = paramsx.append("RoleID", RoleID);
    paramsx = paramsx.append("Version", "2");
    return this.http.get(urlAdNetwork, { headers: headers, params: paramsx }).toPromise();
  }


  /**
   * 2021-10-05 CJR~  Function service to request user notification status [1] - Allowed [0] - Disallowed
   * @param userID
   * @returns [1] - Allowed [0] - Disallowed
   */
  validateUserNotification(userID) {

    let user = new Users();
    user.UserID = userID

    var urlToRequest = hostGeneral + "/api/UserAuth/ValidateUserNotification";

    return this.http.post<Users>(urlToRequest, user, httpOptions).toPromise();
  }

  SetUpMAOOpenEchangeAPI(LandingPageID, LandingPageTkn, AdNetworkAPiID, GlobalParamType, VerticalID) {
    const urlToRequest = `${hostGeneral}/api/LandingPage/SetUpMAOOpenEchangeAPI`;


    let parameters = new HttpParams();
    parameters = parameters.append("AdNetworkAPIID", AdNetworkAPiID);
    parameters = parameters.append("LandingPageID", LandingPageID);
    parameters = parameters.append("LandingPageTkn", LandingPageTkn);
    parameters = parameters.append("GlobalParamType", GlobalParamType);
    parameters = parameters.append("VerticalID", VerticalID);


    return this.http.post<any>(urlToRequest, {
      "AdNetworkAPIID": AdNetworkAPiID,
      "LandingPageID": LandingPageID,
      "LandingPageTkn": LandingPageTkn,
      "GlobalParamType": GlobalParamType,
      "VerticalID": VerticalID,
    }, {
      headers: headers,
      params: parameters
    }).toPromise();

  }

  removeAdCopyTab(CampaignAdCopyID) {
    let parameters = new HttpParams();
    var urlToRequest = hostGeneral + "/api/AdCampaign/deleteAdCopy";
    parameters = parameters.append("CampaignAdCopyID", CampaignAdCopyID);

    return this.http.get(urlToRequest, { headers: headers, params: parameters }).toPromise();

  }

  removeProgramAdCopyLogo(fileName: string) {
    const urlToRequest = `${hostGeneral}/api/SaveImages/RemovePAdCopyLogo`;

    let parameters = new HttpParams();
    parameters = parameters.append("logoFileName", fileName);

    return this.http.post(urlToRequest, {
      "logoFileName": fileName
    }, {
      headers: headers,
      params: parameters
    }).toPromise();
  }

  ShowAverageBidSuggestion(adFeedID, showAverageBids) {

    const urlToRequest = `${hostGeneral}/api/AdFeed/ShowAverageBidSuggestion`;

    let parameters = new HttpParams();
    parameters = parameters.append("AdFeedID", adFeedID);
    parameters = parameters.append("ShowAverageBids", showAverageBids);

    return this.http.post<any>(urlToRequest, {
      'AdFeedID': adFeedID,
      'ShowAverageBids': showAverageBids
    }, {
      headers: headers,
      params: parameters
    });

  }



  saveBidFloor(adFeedID, BidFloor) {

    const urlToRequest = `${hostGeneral}/api/AdFeed/SaveBidFloor`;

    let parameters = new HttpParams();
    parameters = parameters.append("AdFeedID", adFeedID);
    parameters = parameters.append("BidFloor", BidFloor);

    return this.http.post<any>(urlToRequest, {
      'AdFeedID': adFeedID,
      'BidFloor': BidFloor
    }, {
      headers: headers,
      params: parameters
    });

  }


  updateAdFeedVisibleStatus(adFeedID, visible) {

    const urlToRequest = `${hostGeneral}/api/AdFeed/UpdateVisibleAdFeedStatus`;

    let parameters = new HttpParams();
    parameters = parameters.append("AdFeedID", adFeedID);
    parameters = parameters.append("Visible", visible);

    return this.http.post<any>(urlToRequest, {
      'AdFeedID': adFeedID,
      'Visible': visible
    }, {
      headers: headers,
      params: parameters
    });

  }


  GetAverageBidByAdFeed(AdFeedID) {

    const urlToRequest = `${hostGeneral}/api/AdFeed/GetAverageBid`;

    let parameters = new HttpParams();
    parameters = parameters.append("AdFeedID", AdFeedID);
    return this.http.get(urlToRequest, { headers: headers, params: parameters });
  }

  GetBudgetAlertByAdFeedID(AdFeedID) {
    const urlToRequest = `${hostGeneral}/api/BudgetAlert/GetBudgetAlertByAdFeedID`;

    let parameters = new HttpParams();
    parameters = parameters.append("AdFeedID", AdFeedID);
    return this.http.get(urlToRequest, { headers: headers, params: parameters });
  }

  GetBudgetAlertLogByAlertID(budgetAlertID, startDate, endDate) {
    const urlToRequest = `${hostGeneral}/api/BudgetAlert/GetBudgetAlertLogByAlertID`;

    let parameters = new HttpParams();
    parameters = parameters.append("budgetAlertID", budgetAlertID);
    parameters = parameters.append("startDate", startDate);
    parameters = parameters.append("endDate", endDate);

    return this.http.get(urlToRequest, { headers: headers, params: parameters });
  }

  setNewBudgetAlert(budgetAlert: BudgetAlert) {
    const urlToRequest = `${hostGeneral}/api/BudgetAlert/SetNewBudgetAlert`;

    return this.http.post(urlToRequest, budgetAlert, {
      headers: headers
    });

  }

  updateBudgetAlertByAlertID(budgetAlert: BudgetAlert) {
    const urlToRequest = `${hostGeneral}/api/BudgetAlert/UpdateBudgetAlertByAlertID`;

    return this.http.post(urlToRequest, budgetAlert, {
      headers: headers
    });
  }

  // saveAdvertiserFromCampaign(post: any): Observable<any> {
  //   return this.http.post<any>(`${hostGeneral}/api/Company/Save`, post, { headers });
  // }

  saveClickToCallStatus(AdCampaignID: number, PhoneNumber: number, AdUserID: number, ClickToCallStatus: boolean): Observable<any> {
    const TwilioServerDesa = data_settingMAO.TwilioServer;
    //const urlToRequest = `${TwilioServerDesa}/api/TwilioVoiceAPI/Voice/SaveClickToCallStatus`;
    const urlToRequest = `${hostGeneral}/api/TelcoAPINumber/SaveClickToCallStatus`;

    var parametersPost = {
      AdCampaignID: AdCampaignID,
      PhoneNumber: PhoneNumber,
      AdUserID: AdUserID,
      DefaultTelcoNumberSettings: ClickToCallStatus
    }


    return this.http.post<any>(urlToRequest, parametersPost, { headers });

  }



  removeBudgetAlertByID(budgetAlertID) {
    const urlToRequest = `${hostGeneral}/api/BudgetAlert/RemoveBudgetAlert`;

    let parameters = new HttpParams();
    parameters = parameters.append("budgetAlertID", budgetAlertID);
    return this.http.delete(urlToRequest, {
      headers: headers,
      params: parameters
    });
  }


  getInventoryReport(inventoryRequest: InventoryRequest) {

    const urlToRequest = `${hostGeneral}/api/InventoryReport/GetInventoryReport`;

    return this.http.post(urlToRequest, inventoryRequest, { headers });

  }

  getStateByZipCode(zipCode: string) {
    const urlToRequest = `${hostGeneral}/api/InventoryReport/GetStateByZipCode`;

    let parameters = new HttpParams();
    parameters = parameters.append("zipCodeList", JSON.stringify(zipCode));
    return this.http.get(urlToRequest, {
      headers: headers,
      params: parameters
    });

  }


}
